import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_ComprehensiveClinicalAssessment = ({
   itemsRef,
   showErrorFor,
}) => {

   return (
      <form id='ACTS_ComprehensiveClinicalAssessment' className='file-pdf-document'>
         <div className='file-template'>

            <h3> Comprehensive Clinical Assessment </h3>

            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkComprehensive1" id="chkComprehensive1" className='add-only' value="Comprehensive1" /> Initial
                  </td>
                  <td className='w-200'>
                     <input type="checkbox" name="chkComprehensive2" id="chkComprehensive2" className='add-only' value="Comprehensive2" /> Annual Review
                  </td>
                  <td className='w-200'>
                     <input type="checkbox" name="chkComprehensive3" id="chkComprehensive3" className='add-only' value="Comprehensive3" /> Revised
                  </td>
                  <td className='w-150'>
                     <input type="checkbox" name="chkComprehensive4" id="chkComprehensive4" className='add-only' value="Comprehensive4" /> Addendum
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Referral Source:</span>
                     <input type="text" id="txtReferralSource" name="txtReferralSource" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Date of Assessment:</span>
                     <input type="date" id="txtDateAssessment" name="txtDateAssessment" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Consumer Address:</span>
                     <input type="text" id="txtConsumerAddress" name="txtConsumerAddress" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Consumer Phone:</span>
                     <input type="text" id="txtConsumerPhone" name="txtConsumerPhone" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>SSN:</span>
                     <input type="text" id="txtSsn" name="txtSsn" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Emergency Contact:</span>
                     <input type="text" id="txtEmergencyContact" name="txtEmergencyContact" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Phone:</span>
                     <input type="text" id="txtPhone" name="txtPhone" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Email Address:</span>
                     <input type="text" id="txtEmailAddress" name="txtEmailAddress" className='add-only' />
                  </td>
                  <td className='w-250'>&nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Legal Guardian:</span>
               <input type="radio" id="rbLegal1_Yes" name="rbLegal1" className='add-only' value="1" /> Self
               <input type="radio" id="rbLegal1_No" name="rbLegal1" className='add-only' value="0" /> Other (specify):
               <input type="text" id="txtSpecify1" name="txtSpecify1" className='add-only' />
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Type of Health Insurance:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHealth1" id="chkHealth1" className='add-only' value="Health1" /> Health Choice
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHealth2" id="chkHealth2" className='add-only' value="Health2" /> IPRS Funding
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHealth3" id="chkHealth3" className='add-only' value="Health3" /> Medicaid Sandhills
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHealth4" id="chkHealth4" className='add-only' value="Health4" /> Medicaid Cardinal
                  </td>
                  <td className='w-500'>
                     <input type="checkbox" name="chkHealth5" id="chkHealth5" className='add-only' value="Health5" /> Other: &nbsp;
                     <input type="text" id="txtSpecifyOther" name="txtSpecifyOther" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Individuals participating in the assessment:</span>
                     <input type="text" id="txtIndividuals" name="txtIndividuals" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Location of assessment:</span>
                     <input type="text" id="txtLocation" name="txtLocation" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Name/Credentials of person completing assessment:</span>
                     <input type="text" id="txtCredentials" name="txtCredentials" className='add-only' />
                  </td>
                  <td className='w-375'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Summary of Presenting Concern: (List factors that led client to seek out services, what do the current problems look
                  like, age/time of onset, how long problems have been occurring, the frequency of behavioral concerns, intensity, and
                  environments in which problems occur in. Include recent progress, changes, or developments) *Include current and
                  history of Legal Involvement</span>
               <textarea id="txtSummary" name="txtSummary" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Reason for referral:</span>
               <textarea id="txtSummaryReason" name="txtSummaryReason" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Behavior:</span>
               <textarea id="txtBehavior1" name="txtBehavior1" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Frequency:</span>
                     <input type="text" id="txtFrequency1" name="txtFrequency1" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Duration:</span>
                     <input type="text" id="txtDuration11" name="txtDuration11" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Intensity:</span>
                     <input type="text" id="txtIntensity1" name="txtIntensity1" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Behavior:</span>
               <textarea id="txtBehavior2" name="txtBehavior2" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Frequency:</span>
                     <input type="text" id="txtFrequency2" name="txtFrequency2" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Duration:</span>
                     <input type="text" id="txtDuration2" name="txtDuration2" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Intensity:</span>
                     <input type="text" id="txtIntensity2" name="txtIntensity2" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Behavior:</span>
               <textarea id="txtBehavior3" name="txtBehavior3" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Frequency:</span>
                     <input type="text" id="txtFrequency3" name="txtFrequency3" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Duration:</span>
                     <input type="text" id="txtDuration3" name="txtDuration3" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Intensity:</span>
                     <input type="text" id="txtIntensity3" name="txtIntensity3" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Summary of external factors affecting behaviors: </span>
               <span className='small'>(List environmental elements, family changes, traumatic
                  experiences, and other experiences that may be contributing to the behavioral presentation noted above)</span>
               <textarea id="txtBehaviorSummary" name="txtBehaviorSummary" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Has the client been treated for Problem Sexual Behavior?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="radio" id="rbLegal_Yes" name="rbLegal" className='add-only' value="1" /> Yes
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbLegal_No" name="rbLegal" className='add-only' value="0" /> No
                  </td>
                  <td className='w-450'>
                     <input type="radio" id="rbLegal_Ye" name="rbLegal" className='add-only' value="2" /> N/A-no reported Problem Sexual Behaviors
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="radio" id="rbLegal_Ys" name="rbLegal" className='add-only' value="3" /> Not relevant
                  </td>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-450'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>If Yes, please describe the incident and corresponding treatment.</span>
               <textarea id="txtBehaviorDescribe" name="txtBehaviorDescribe" className='add-only'></textarea>
            </p>
            <h3>
               Demographic Information
            </h3>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Ethnicity & Race</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbEthnicity_Yes" name="rbEthnicity" className='add-only' value="1" /> Hispanic Origin
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEthnicity_No" name="rbEthnicity" className='add-only' value="0" /> Asian
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEthnicity_Nq" name="rbEthnicity" className='add-only' value="2" /> Not Hispanic Origin
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbEthnicity_Nw" name="rbEthnicity" className='add-only' value="3" /> White/Caucasian
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEthnicity_Nr" name="rbEthnicity" className='add-only' value="4" /> African American
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEthnicity_Nt" name="rbEthnicity" className='add-only' value="5" /> Multiracial
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbEthnicity_Ny" name="rbEthnicity" className='add-only' value="6" /> Native American
                  </td>
                  <td className='w-500'>
                     <input type="radio" id="rbEthnicity_Nu" name="rbEthnicity" className='add-only' value="7" /> Other
                     <input type="text" id="txtIntensityOther" name="txtIntensityOther" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbEthnicity_Ni" name="rbEthnicity" className='add-only' value="8" /> Asian American
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEthnicity_Np" name="rbEthnicity" className='add-only' value="9" /> Prefer to not disclose
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Living arrangement</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbLiving_Yes" name="rbLiving" className='add-only' value="1" /> Own private residence/rental
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLiving_No" name="rbLiving" className='add-only' value="0" /> Community ICF-MR
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLiving_Nq" name="rbLiving" className='add-only' value="2" /> Correctional Facility
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbLiving_Nw" name="rbLiving" className='add-only' value="3" /> Other's private residence
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLiving_Nr" name="rbLiving" className='add-only' value="4" /> Homeless (or at risk)
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLiving_Nt" name="rbLiving" className='add-only' value="5" /> Rented room/dorm etc.
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbLiving_Ny" name="rbLiving" className='add-only' value="6" /> Halfway house
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLiving_Nu" name="rbLiving" className='add-only' value="7" /> Adult Care Home
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLiving_Ni" name="rbLiving" className='add-only' value="8" /> Nursing Home
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbLiving_Np" name="rbLiving" className='add-only' value="9" /> Institution
                  </td>
                  <td className='w-500'>
                     <input type="radio" id="rbLiving_Nz" name="rbLiving" className='add-only' value="10" /> Other:
                     <input type="text" id="txtLiving" name="txtLiving" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbLiving_Nx" name="rbLiving" className='add-only' value="11" /> Alternative Family Living
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Marital Status</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbMarital_Yes" name="rbMarital" className='add-only' value="1" /> Single
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbMarital_No" name="rbMarital" className='add-only' value="0" /> Widowed
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbMarital_Nq" name="rbMarital" className='add-only' value="2" /> Married
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbMarital_Nw" name="rbMarital" className='add-only' value="3" /> Domestic Partners
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbMarital_Nr" name="rbMarital" className='add-only' value="4" /> Divorced
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbMarital_Nt" name="rbMarital" className='add-only' value="5" /> Prefer not to respond
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbMarital_Ny" name="rbMarital" className='add-only' value="6" /> Separated
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Sexual Orientation</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbSexual_Yes" name="rbSexual" className='add-only' value="1" /> Heterosexual
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbSexual_No" name="rbSexual" className='add-only' value="0" /> Questioning
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbSexual_Nq" name="rbSexual" className='add-only' value="2" /> Gay
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbSexual_Nw" name="rbSexual" className='add-only' value="3" /> Pan-Sexual
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbSexual_Nr" name="rbSexual" className='add-only' value="4" /> Lesbian
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbSexual_Nt" name="rbSexual" className='add-only' value="5" /> A-Sexual
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbSexual_Ny" name="rbSexual" className='add-only' value="6" /> Bi-sexual
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbSexual_Nu" name="rbSexual" className='add-only' value="7" /> Prefer not to respond
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbSexual_Ni" name="rbSexual" className='add-only' value="8" /> Queer
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbSexual_Np" name="rbSexual" className='add-only' value="9" /> Other:
                     <input type="text" id="txtSexual" name="txtSexual" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Gender Identity</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbGender_Yes" name="rbGender" className='add-only' value="1" /> Male
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbGender_No" name="rbGender" className='add-only' value="0" /> Non-Binary
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbGender_Nq" name="rbGender" className='add-only' value="2" /> Female
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbGender_Nw" name="rbGender" className='add-only' value="3" /> Trans-gendered Male
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbGender_Nr" name="rbGender" className='add-only' value="4" /> Trans-gendered Female
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbGender_Nt" name="rbGender" className='add-only' value="5" /> Other:
                     <input type="text" id="txtGender1" name="txtGender1" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Employment  Description</span>
               <textarea id="txtEmployment" name="txtEmployment" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Education</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-500'>
                     <input type="radio" id="rbEducation_Yes" name="rbEducation" className='add-only' value="1" /> Highest Grade Completed:
                     <input type="text" id="txtGender2" name="txtGender2" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEducation_No" name="rbEducation" className='add-only' value="0" /> College Degree
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbEducation_Nq" name="rbEducation" className='add-only' value="2" /> GED
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEducation_Nw" name="rbEducation" className='add-only' value="3" /> Graduate Degree
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEducation_Nr" name="rbEducation" className='add-only' value="4" /> High School Diploma
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbEducation_Nt" name="rbEducation" className='add-only' value="5" /> Postgraduate
                  </td>
                  <td className='w-500'>
                     <input type="radio" id="rbEducation_Ny" name="rbEducation" className='add-only' value="6" /> Some College
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Languages</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbLanguages_Yes" name="rbLanguages" className='add-only' value="1" /> English
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLanguages_No" name="rbLanguages" className='add-only' value="0" /> Italian
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLanguages_Nq" name="rbLanguages" className='add-only' value="2" /> Spanish
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbLanguages_Nw" name="rbLanguages" className='add-only' value="3" /> Chinese
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLanguages_Nr" name="rbLanguages" className='add-only' value="4" /> German
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLanguages_Nt" name="rbLanguages" className='add-only' value="5" /> Vietnamese
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbLanguages_Ny" name="rbLanguages" className='add-only' value="6" /> French
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLanguages_Nu" name="rbLanguages" className='add-only' value="7" /> Sign Language
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbLanguages_Ni" name="rbLanguages" className='add-only' value="8" /> Arabic
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbLanguages_Np" name="rbLanguages" className='add-only' value="9" /> Other:
                     <input type="text" id="txtLanguages" name="txtLanguages" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Religion preference</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbReligion_Yes" name="rbReligion" className='add-only' value="1" /> Catholic
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbReligion_No" name="rbReligion" className='add-only' value="0" /> Hindu
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbReligion_Nq" name="rbReligion" className='add-only' value="2" /> Christian
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbReligion_Nw" name="rbReligion" className='add-only' value="3" /> Agnostic
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbReligion_Nr" name="rbReligion" className='add-only' value="4" /> Jewish
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbReligion_Nt" name="rbReligion" className='add-only' value="5" /> Atheist
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbReligion_Ny" name="rbReligion" className='add-only' value="6" /> Muslim
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbReligion_Nu" name="rbReligion" className='add-only' value="7" /> Unaffiliated
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbReligion_Ni" name="rbReligion" className='add-only' value="8" /> Buddhist
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbReligion_Np" name="rbReligion" className='add-only' value="9" /> Other:
                     <input type="text" id="txtReligion" name="txtReligion" className='add-only' />
                  </td>
               </tr>
            </table>
            <h3>
               Psychiatric and Substance Abuse Services / History
            </h3>
            <p className='w-750'>
               <input type="checkbox" name="chkServices" id="chkServices" className='add-only' value="Services" />  No previous treatment history
            </p>
            <table>
               <tr>
                  <td className='w-150'>
                     <span className='eleHeader'>Outpatient Provider Name(s)</span>
                     <input type="text" id="txtOutpatientProvider1" name="txtOutpatientProvider1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Dates of Service/Length of Treatment</span>
                     <input type="text" id="txtDatesService1" name="txtDatesService1" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Outcome:</span> <span className='small'>(What worked or did not work for the individual receiving the service)</span>
                     <input type="text" id="txtOutcome1" name="txtOutcome1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Diagnosis at discharge</span>
                     <input type="text" id="txtDiagnosis1" name="txtDiagnosis1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtOutpatientProvider2" name="txtOutpatientProvider2" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDatesService2" name="txtDatesService2" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcome2" name="txtOutcome2" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDiagnosis2" name="txtDiagnosis2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtOutpatientProvider3" name="txtOutpatientProvider3" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDatesService3" name="txtDatesService3" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcome3" name="txtOutcome3" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDiagnosis3" name="txtDiagnosis3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtOutpatientProvider4" name="txtOutpatientProvider4" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDatesService4" name="txtDatesService4" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcome4" name="txtOutcome4" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDiagnosis4" name="txtDiagnosis4" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtOutpatientProvider5" name="txtOutpatientProvider5" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDatesService5" name="txtDatesService5" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcome5" name="txtOutcome5" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDiagnosis5" name="txtDiagnosis5" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-150'>
                     <span className='eleHeader'>Substance T/X or Other Provider Name(s)</span>
                     <input type="text" id="txtOutpatientProviderSubstance" name="txtOutpatientProviderSubstance" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Dates of Service/Length of Treatment</span>
                     <input type="text" id="txtDatesServiceLength" name="txtDatesServiceLength" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Outcome:</span> <span className='small'>(What worked or did not work for the individual receiving the service)</span>
                     <input type="text" id="txtOutcomeWhat" name="txtOutcomeWhat" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Diagnosis at discharge</span>
                     <input type="text" id="txtDiagnosisDischarge" name="txtDiagnosisDischarge" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtOutpatientProviderSubstance1" name="txtOutpatientProviderSubstance1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDatesServiceLength1" name="txtDatesServiceLength1" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeWhat1" name="txtOutcomeWhat1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDiagnosisDischarge1" name="txtDiagnosisDischarge1" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Please list additional information on prior mental health diagnoses if applicable:</span>
               <textarea id="txtNotesList" name="txtNotesList" className='add-only'></textarea>
            </p>
            <h3>
               Out of Home Placement History
            </h3>
            <p className='w-750'>
               <input type="checkbox" name="chkServices1" id="chkServices1" className='add-only' value="Services1" />  No previous history
            </p>
            <table>
               <tr>
                  <td className='w-150'>
                     <span className='eleHeader'>Hospitalizations</span>
                     <input type="text" id="txtHospitalizations" name="txtHospitalizations" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Dates of Service/Length of Treatment</span>
                     <input type="text" id="txtDatesServiceLengthTreatment" name="txtDatesServiceLength" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Outcome:</span> <span className='small'>(What worked or did not work for the individual receiving the service)</span>
                     <input type="text" id="txtOutcomeWorked" name="txtOutcomeWorked" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Diagnosis at discharge</span>
                     <input type="text" id="txtDiagnosisUischarge" name="txtDiagnosisUischarge" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtHospitalizations1" name="txtHospitalizations1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDatesServiceLengthTreatment1" name="txtDatesServiceLength1" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeWorked1" name="txtOutcomeWorked1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDiagnosisUischarge1" name="txtDiagnosisUischarge1" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-150'>
                     <span className='eleHeader'>Group Home</span>
                     <input type="text" id="txtGroupHome" name="txtGroupHome" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Dates of Service/Length of Treatment</span>
                     <input type="text" id="txtDatesServiceLengthTreatmen" name="txtDatesServiceLengthTreatmen" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Outcome:</span> <span className='small'>(What worked or did not work for the individual receiving the service)</span>
                     <input type="text" id="txtOutcomeWorke" name="txtOutcomeWorke" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Diagnosis at discharge</span>
                     <input type="text" id="txtDiagnosisUischarg" name="txtDiagnosisUischarg" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtGroupHome1" name="txtGroupHome1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDatesServiceLengthTreatmen1" name="txtDatesServiceLengthTreatmen1" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeWorke1" name="txtOutcomeWorke1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDiagnosisUischarg1" name="txtDiagnosisUischarg1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtGroupHome2" name="txtGroupHome2" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDatesServiceLengthTreatmen2" name="txtDatesServiceLengthTreatmen2" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeWorke2" name="txtOutcomeWorke2" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDiagnosisUischarg2" name="txtDiagnosisUischarg2" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-150'>
                     <span className='eleHeader'>PRTF</span>
                     <input type="text" id="txtGroupHom" name="txtGroupHom" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Dates of Service/Length of Treatment</span>
                     <input type="text" id="txtDatesServiceLengthTreatme" name="txtDatesServiceLengthTreatme" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Outcome:</span> <span className='small'>(What worked or did not work for the individual receiving the service)</span>
                     <input type="text" id="txtOutcomeWork" name="txtOutcomeWork" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Diagnosis at discharge</span>
                     <input type="text" id="txtDiagnosisUischar" name="txtDiagnosisUischar" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtGroupHom1" name="txtGroupHom1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDatesServiceLengthTreatme1" name="txtDatesServiceLengthTreatme1" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeWork1" name="txtOutcomeWork1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDiagnosisUischar1" name="txtDiagnosisUischar1" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-150'>
                     <span className='eleHeader'>Therapeutic foster</span>
                     <input type="text" id="txtTherapeutic" name="txtTherapeutic" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Dates of Service/Length of Treatment</span>
                     <input type="text" id="txtDatesServiceLengthTreatm" name="txtDatesServiceLengthTreatm" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Outcome:</span> <span className='small'>(What worked or did not work for the individual receiving the service)</span>
                     <input type="text" id="txtOutcomeWor" name="txtOutcomeWor" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <span className='eleHeader'>Diagnosis at discharge</span>
                     <input type="text" id="txtDiagnosisUischa" name="txtDiagnosisUischa" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtTherapeutic1" name="txtTherapeutic1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDatesServiceLengthTreatm1" name="txtDatesServiceLengthTreatm1" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeWor1" name="txtOutcomeWor1" className='add-only' />
                  </td>
                  <td className='w-225'>
                     <input type="text" id="txtDiagnosisUischa1" name="txtDiagnosisUischa1" className='add-only' />
                  </td>
               </tr>
            </table>
            <h3>
               History of Abuse/Neglect/Trauma/Stressors <span className='small'>(If yes, follow up with Trauma
                  Screening Questionnaire and attach)</span>
            </h3>
            <p className='w-750'>
               <span className='eleHeader'>Physical Abuse History</span>
               <input type="radio" id="rbPhysicalAbuse1_Yes" name="rbPhysicalAbuse1" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse1_No" name="rbPhysicalAbuse1" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails1" name="txtPhysicalAbuseDetails1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Emotional Abuse History</span>
               <input type="radio" id="rbPhysicalAbuse2_Yes" name="rbPhysicalAbuse2" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse2_No" name="rbPhysicalAbuse2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails2" name="txtPhysicalAbuseDetails2" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Sexual Abuse History</span>
               <input type="radio" id="rbPhysicalAbuse3_Yes" name="rbPhysicalAbuse3" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse3_No" name="rbPhysicalAbuse3" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails3" name="txtPhysicalAbuseDetails3" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Neglect History</span>
               <input type="radio" id="rbPhysicalAbuse4_Yes" name="rbPhysicalAbuse4" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse4_No" name="rbPhysicalAbuse4" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails4" name="txtPhysicalAbuseDetails4" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'> Other reported trauma</span>
               <input type="radio" id="rbPhysicalAbuse5_Yes" name="rbPhysicalAbuse5" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse5_No" name="rbPhysicalAbuse5" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails5" name="txtPhysicalAbuseDetails5" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Life span Stressors</span>
               <input type="radio" id="rbPhysicalAbuse6_Yes" name="rbPhysicalAbuse6" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse6_No" name="rbPhysicalAbuse6" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails6" name="txtPhysicalAbuseDetails6" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Current DSS Involvement</span>
               <input type="radio" id="rbPhysicalAbuse7_Yes" name="rbPhysicalAbuse7" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse7_No" name="rbPhysicalAbuse7" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails7" name="txtPhysicalAbuseDetails7" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>History of Department of Social Services (DSS) Involvement</span>
               <input type="radio" id="rbPhysicalAbuse8_Yes" name="rbPhysicalAbuse8" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse8_No" name="rbPhysicalAbuse8" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails8" name="txtPhysicalAbuseDetails8" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               Dates of DSS Involvement <input type="date" id="txtInvolvement" name="txtInvolvement" className='add-only' />
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Outcome of DSS Involvement</span>
               <input type="radio" id="rbPhysicalAbuse9_Yes" name="rbPhysicalAbuse9" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse9_No" name="rbPhysicalAbuse9" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails9" name="txtPhysicalAbuseDetails9" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>History of Child Protective Services (CPS) Involvement</span>
               <input type="radio" id="rbPhysicalAbuse10_Yes" name="rbPhysicalAbuse10" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse10_No" name="rbPhysicalAbuse10" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails10" name="txtPhysicalAbuseDetails10" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Need to file a report</span>
               <input type="radio" id="rbPhysicalAbuse11_Yes" name="rbPhysicalAbuse11" className='add-only' value="1" /> Yes
               <input type="radio" id="rbPhysicalAbuse11_No" name="rbPhysicalAbuse11" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtPhysicalAbuseDetails11" name="txtPhysicalAbuseDetails11" className='add-only'></textarea>
            </p>
            <h3>
               LEGAL HISTORY
            </h3>
            <p className='w-750'>
               <input type="checkbox" name="chkServicesLegal" id="chkServicesLegal" className='add-only' value="ServicesLegal" />  No Legal History Reported
            </p>
            <h4>
               Legal Charges <span className='small'>(Historic and Current)</span>
            </h4>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Charges:</span>
                     <input type="text" id="txtCharges" name="txtCharges" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Has the individual been convicted or adjudicated of the charge?</span>
                     <input type="radio" id="rbCharges_Yes" name="rbCharges" className='add-only' value="1" /> Yes
                     <input type="radio" id="rbCharges_No" name="rbCharges" className='add-only' value="0" /> No
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Date of the arrest:</span>
                     <input type="date" id="txtDateArrest" name="txtDateArrest" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="text" id="txtCharges1" name="txtCharges1" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbCharges1_Yes" name="rbCharges1" className='add-only' value="1" /> Yes
                     <input type="radio" id="rbCharges1_No" name="rbCharges1" className='add-only' value="0" /> No
                  </td>
                  <td className='w-250'>
                     <input type="date" id="txtDateArrest1" name="txtDateArrest1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="text" id="txtCharges23" name="txtCharges23" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbCharges2_Yes" name="rbCharges2" className='add-only' value="1" /> Yes
                     <input type="radio" id="rbCharges2_No" name="rbCharges2" className='add-only' value="0" /> No
                  </td>
                  <td className='w-250'>
                     <input type="date" id="txtDateArrest2" name="txtDateArrest2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="text" id="txtCharges31" name="txtCharges31" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbCharges3_Yes" name="rbCharges3" className='add-only' value="1" /> Yes
                     <input type="radio" id="rbCharges3_No" name="rbCharges3" className='add-only' value="0" /> No
                  </td>
                  <td className='w-250'>
                     <input type="date" id="txtDateArrest3" name="txtDateArrest3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="text" id="txtCharges4" name="txtCharges4" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbCharges4_Yes" name="rbCharges4" className='add-only' value="1" /> Yes
                     <input type="radio" id="rbCharges4_No" name="rbCharges4" className='add-only' value="0" /> No
                  </td>
                  <td className='w-250'>
                     <input type="date" id="txtDateArrest4" name="txtDateArrest4" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkIndividual1" id="chkIndividual1" className='add-only' value="Individual1" /> Individual has open/active court case(s)
                  </td>
                  <td className='w-375'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkIndividual2" id="chkIndividual2" className='add-only' value="Individual2" /> Individual has upcoming court dates
                  </td>
                  <td className='w-375'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkIndividual3" id="chkIndividual3" className='add-only' value="Individual3" /> Individual is on probation
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Court dates:</span>
                     <input type="date" id="txtCourtDates3" name="txtCourtDates3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkIndividual4" id="chkIndividual4" className='add-only' value="Individual4" /> Individual is on parole
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Probation end date:</span>
                     <input type="date" id="txtCourtDates4" name="txtCourtDates4" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkIndividual5" id="chkIndividual5" className='add-only' value="Individual5" /> Individual has spent time in prison/jail/detention
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Parole end date:</span>
                     <input type="date" id="txtCourtDates5" name="txtCourtDates5" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkIndividual6" id="chkIndividual6" className='add-only' value="Individual6" /> Individual has a history of legal involvement
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Dates of stay:</span>
                     <input type="date" id="txtCourtDates6" name="txtCourtDates6" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkIndividual7" id="chkIndividual7" className='add-only' value="Individual7" /> Individual is court ordered to attend treatment
                  </td>
                  <td className='w-375'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkIndividual8" id="chkIndividual8" className='add-only' value="Individual8" /> Individual has DJJ supervision
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Supervision ends:</span>
                     <input type="date" id="txtCourtDates8" name="txtCourtDates8" className='add-only' />
                  </td>
               </tr>
            </table>
            <h4>
               Family Legal Involvement <span className='small'>(Historic and Current)</span>
            </h4>
            <table>
               <tr>
                  <td className='w-200'>
                     <span className='eleHeader'>Individual's relationship to client</span>
                     <input type="text" id="txtCharges6" name="txtCharges6" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <span className='eleHeader'>Living with the client</span>
                     <input type="text" id="txtLivingWith" name="txtLivingWith" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Type of charge</span>
                     <input type="text" id="txtTypeCharge" name="txtTypeCharge" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <span className='eleHeader'>Historical or Current</span>
                     <input type="text" id="txtHistoricalCurrent" name="txtHistoricalCurrent" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="text" id="txtCharges2" name="txtCharges2" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtLivingWith2" name="txtLivingWith2" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtTypeCharge2" name="txtTypeCharge2" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtHistoricalCurrent2" name="txtHistoricalCurrent2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="text" id="txtCharges34" name="txtCharges34" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtLivingWith3" name="txtLivingWith3" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtTypeCharge3" name="txtTypeCharge3" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtHistoricalCurrent3" name="txtHistoricalCurrent3" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Client or family gang involved of gang involvement</span>
               <input type="radio" id="rbClient_Yes" name="rbClient" className='add-only' value="1" /> Yes
               <input type="radio" id="rbClient_No" name="rbClient" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               If Yes, describe the extent
               <textarea id="txtDescribe" name="txtDescribe" className='add-only'></textarea>
            </p>
            <h3>
               EDUCATION
            </h3>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Education Status</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkEducation1" id="chkEducation1" className='add-only' value="Education1" /> Client graduated high school
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkEducation2" id="chkEducation2" className='add-only' value="Education2" /> Client is enrolled in graduate degree
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkEducation3" id="chkEducation3" className='add-only' value="Education3" /> Completed GED
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkEducation4" id="chkEducation4" className='add-only' value="Education4" /> Client completed graduate degree
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkEducation5" id="chkEducation5" className='add-only' value="Education5" /> Client completed vocational education
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkEducation9" id="chkEducation9" className='add-only' value="Education9" /> Client is currently not in school
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkEducation6" id="chkEducation6" className='add-only' value="Education6" /> Client is enrolled in college
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkEducation16" id="chkEducation16" className='add-only' value="Education16" /> Client is in need of enrollment
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkEducation7" id="chkEducation7" className='add-only' value="Education7" /> Client graduated college
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkEducation8" id="chkEducation8" className='add-only' value="Education8" /> Client is enrolled in school
                  </td>
               </tr>
            </table>
            <h4>
               School Information
            </h4>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>School Name:</span>
                     <input type="text" id="txtSchoolName" name="txtSchoolName" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Grade in school:</span>
                     <input type="text" id="txtGrade" name="txtGrade" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Highest Grade Completed:</span>
                     <input type="text" id="txtHighestGrade" name="txtHighestGrade" className='add-only' />
                  </td>
               </tr>
            </table>
            <h4>
               Teacher/ Counselor
            </h4>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Teacher's Name:</span>
                     <input type="text" id="txtTeacherName" name="txtTeacherName" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Counselor's Name:</span>
                     <input type="text" id="txtCounselor" name="txtCounselor" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>School Social Worker:</span>
                     <input type="text" id="txtSocialWorker" name="txtSocialWorker" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Learning Supports</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLearning1" id="chkLearning1" className='add-only' value="Learning1" /> Needs academic supports
                  </td>
                  <td className='w-500'>
                     <input type="checkbox" name="chkLearning2" id="chkLearning2" className='add-only' value="Learning2" /> Learning Disability:
                     <input type="text" id="txtLearning1" name="txtLearning1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLearning3" id="chkLearning3" className='add-only' value="Learning3" /> Has an IEP
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLearning4" id="chkLearning4" className='add-only' value="Learning4" /> Has a 504 Plan
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Literacy Essentials: Components of Reading & Writing</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-500'>
                     <input type="checkbox" name="chkLiteracy1" id="chkLiteracy1" className='add-only' value="Literacy1" /> Phonemic Awareness ( word recognition)
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiteracy2" id="chkLiteracy2" className='add-only' value="Literacy2" /> Phonics
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiteracy3" id="chkLiteracy3" className='add-only' value="Literacy3" /> Fluency
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiteracy4" id="chkLiteracy4" className='add-only' value="Literacy4" /> Vocabulary
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiteracy5" id="chkLiteracy5" className='add-only' value="Literacy5" /> Comprehension
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiteracy6" id="chkLiteracy6" className='add-only' value="Literacy6" /> Spelling
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiteracy7" id="chkLiteracy7" className='add-only' value="Literacy7" /> Writing
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Educational Standing</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkStanding1" id="chkStanding1" className='add-only' value="Standing1" /> Above Grade Level
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkStanding2" id="chkStanding2" className='add-only' value="Standing2" /> On Grade Level
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkStanding3" id="chkStanding3" className='add-only' value="Standing3" /> Below Grade Level
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Educational Challenges</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkChallenges1" id="chkChallenges1" className='add-only' value="Challenges1" /> Repeated grades
                  </td>
                  <td className='w-250'>
                     Which grades:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtChallenges1" name="txtChallenges1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkChallenges2" id="chkChallenges2" className='add-only' value="Challenges2" /> Behavioral Problems in
                     school
                  </td>
                  <td className='w-250'>
                     Specifiy challenges:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtChallenges2" name="txtChallenges2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkChallenges3" id="chkChallenges3" className='add-only' value="Challenges3" /> Academic Areas of Need
                  </td>
                  <td className='w-250'>
                     Specifiy Needs:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtChallenges3" name="txtChallenges3" className='add-only' />
                  </td>
               </tr>
            </table>
            <h4>
               Educational Strengths
            </h4>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Educational/Vocational Goals:</span>
                     <input type="text" id="txtVocational" name="txtVocational" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Academic Area of Strength:</span>
                     <input type="text" id="txtAcademic" name="txtAcademic" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Protective Factors</span>
               <textarea id="txtProtective" name="txtProtective" className='add-only'></textarea>
            </p>
            <h4>
               Suspensions
            </h4>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Dates of suspensions in current school year:</span>
                     <input type="date" id="txtSuspensions" name="txtSuspensions" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Duration of suspensions:</span>
                     <input type="text" id="txtDuration" name="txtDuration" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Additional Information on Suspension </span><span className='small'>(barriers with school staff)</span>
               <textarea id="txtAdditionalInformation" name="txtAdditionalInformation" className='add-only'></textarea>
            </p>
            <h4>
               Expulsions
            </h4>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Dates of expulsions during current school year:</span>
                     <input type="date" id="txtSuspensions1" name="txtSuspensions1" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Duration of expulsions:</span>
                     <input type="text" id="txtDuration1" name="txtDuration1" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Additional Information on Expulsion </span><span className='small'>(barriers with school staff)</span>
               <textarea id="txtAdditionalInformation1" name="txtAdditionalInformation1" className='add-only'></textarea>
            </p>
            <h3>
               INDIVIDUAL AND ENVIRONMENTAL STRENGTHS
            </h3>
            <p className='w-750'>
               <span className='eleHeader'>Spiritual Expression</span>
               <input type="radio" id="rbSpiritual1_Yes" name="rbSpiritual1" className='add-only' value="1" /> Yes
               <input type="radio" id="rbSpiritual1_No" name="rbSpiritual1" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtSpiritual1" name="txtSpiritual1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Cultural Participation</span>
               <input type="radio" id="rbSpiritual2_Yes" name="rbSpiritual2" className='add-only' value="1" /> Yes
               <input type="radio" id="rbSpiritual2_No" name="rbSpiritual2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtSpiritual2" name="txtSpiritual2" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Supportive Services</span>
               <input type="radio" id="rbSpiritual3_Yes" name="rbSpiritual3" className='add-only' value="1" /> Yes
               <input type="radio" id="rbSpiritual3_No" name="rbSpiritual3" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtSpiritual3" name="txtSpiritual3" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Pro-Social Activities</span>
               <input type="radio" id="rbSpiritual4_Yes" name="rbSpiritual4" className='add-only' value="1" /> Yes
               <input type="radio" id="rbSpiritual4_No" name="rbSpiritual4" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtSpiritual4" name="txtSpiritual4" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Social Support Network</span>
               <input type="radio" id="rbSpiritual5_Yes" name="rbSpiritual5" className='add-only' value="1" /> Yes
               <input type="radio" id="rbSpiritual5_No" name="rbSpiritual5" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtSpiritual5" name="txtSpiritual5" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Identified Strengths</span>
               <input type="radio" id="rbSpiritual6_Yes" name="rbSpiritual6" className='add-only' value="1" /> Yes
               <input type="radio" id="rbSpiritual6_No" name="rbSpiritual6" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtSpiritual6" name="txtSpiritual6" className='add-only'></textarea>
            </p>
            <h3>
               CURRENT LIVING SITUATION/ENVIRONMENT
            </h3>
            <table>
               <tr>
                  <td className='w-150'>
                     <span className='eleHeader'>Household Members</span>
                     <input type="text" id="txtHousehold" name="txtHousehold" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <span className='eleHeader'>Age</span>
                     <input type="text" id="txtAge" name="txtAge" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <span className='eleHeader'>Gender</span>
                     <input type="radio" id="rbGender12_Yes" name="rbGender12" className='add-only' value="1" /> M
                     <input type="radio" id="rbGender12_No" name="rbGender12" className='add-only' value="0" /> F
                  </td>
                  <td className='w-200'>
                     <span className='eleHeader'>Relationship to Client</span>
                     <input type="text" id="txtRelationshipClient" name="txtRelationshipClient" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <span className='eleHeader'>Describe Relationship</span>
                     <input type="text" id="txtDescribeRelationship" name="txtDescribeRelationship" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtHousehold11" name="txtHousehold1" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAge1" name="txtAge1" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="radio" id="rbGender1_Yes" name="rbGender1" className='add-only' value="1" /> M
                     <input type="radio" id="rbGender1_No" name="rbGender1" className='add-only' value="0" /> F
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtRelationshipClient1" name="txtRelationshipClient1" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtDescribeRelationship1" name="txtDescribeRelationship1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtHousehold21" name="txtHousehold21" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAge2" name="txtAge2" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="radio" id="rbGender2_Yes" name="rbGender2" className='add-only' value="1" /> M
                     <input type="radio" id="rbGender2_No" name="rbGender2" className='add-only' value="0" /> F
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtRelationshipClient2" name="txtRelationshipClient2" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtDescribeRelationship2" name="txtDescribeRelationship2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtHousehold31" name="txtHousehold31" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAge3" name="txtAge3" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="radio" id="rbGender3_Yes" name="rbGender3" className='add-only' value="1" /> M
                     <input type="radio" id="rbGender3_No" name="rbGender3" className='add-only' value="0" /> F
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtRelationshipClient3" name="txtRelationshipClient3" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtDescribeRelationship3" name="txtDescribeRelationship3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtHousehold41" name="txtHousehold41" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAge4" name="txtAge4" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="radio" id="rbGender4_Yes" name="rbGender4" className='add-only' value="1" /> M
                     <input type="radio" id="rbGender4_No" name="rbGender4" className='add-only' value="0" /> F
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtRelationshipClient4" name="txtRelationshipClient4" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtDescribeRelationship4" name="txtDescribeRelationship4" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtHousehold51" name="txtHousehold51" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAge5" name="txtAge5" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="radio" id="rbGender5_Yes" name="rbGender5" className='add-only' value="1" /> M
                     <input type="radio" id="rbGender5_No" name="rbGender5" className='add-only' value="0" /> F
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtRelationshipClient5" name="txtRelationshipClient5" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtDescribeRelationship5" name="txtDescribeRelationship5" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtHousehold61" name="txtHousehold61" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAge6" name="txtAge6" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="radio" id="rbGender6_Yes" name="rbGender6" className='add-only' value="1" /> M
                     <input type="radio" id="rbGender6_No" name="rbGender6" className='add-only' value="0" /> F
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtRelationshipClient6" name="txtRelationshipClient6" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtDescribeRelationship6" name="txtDescribeRelationship6" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Are there any other members of immediate family living outside of the household</span>
               <input type="radio" id="rbHousehold1_Yes" name="rbHousehold1" className='add-only' value="1" /> Yes
               <input type="radio" id="rbHousehold1_No" name="rbHousehold1" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtHousehold1" name="txtHousehold1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Is the current living environment safe?</span>
               <input type="radio" id="rbHousehold2_Yes" name="rbHousehold2" className='add-only' value="1" /> Yes
               <input type="radio" id="rbHousehold2_No" name="rbHousehold2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtHousehold2" name="txtHousehold2" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Are there barriers to stable housing</span>
               <input type="radio" id="rbHousehold3_Yes" name="rbHousehold3" className='add-only' value="1" /> Yes
               <input type="radio" id="rbHousehold3_No" name="rbHousehold3" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtHousehold3" name="txtHousehold3" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Have you had frequent moves</span>
               <input type="radio" id="rbHousehold4_Yes" name="rbHousehold4" className='add-only' value="1" /> Yes
               <input type="radio" id="rbHousehold4_No" name="rbHousehold4" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtHousehold4" name="txtHousehold4" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Length of time at residence</span>
                     <input type="text" id="txtLength" name="txtLength" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Source of income?</span><span className='small'>(Work, WIC, Housing assistance)</span>
                     <input type="text" id="txtSource" name="txtSource" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Source of transportation?</span>
               <textarea id="txtTransportation1" name="txtTransportation1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Environmental Strengths</span>
               <textarea id="txtTransportation21" name="txtTransportation21" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Environmental Needs</span>
               <textarea id="txtTransportation2" name="txtTransportation2" className='add-only'></textarea>
            </p>
            <h3>
               FAMILY HISTORY
            </h3>
            <p className='w-750'>
               <span className='eleHeader'>Relationship and Marital History</span>
               <textarea id="txtRelationship" name="txtRelationship" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Legal Guardian</span>
               <input type="radio" id="rbHousehold5_Yes" name="rbHousehold5" className='add-only' value="1" /> Yes
               <input type="radio" id="rbHousehold5_No" name="rbHousehold5" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtHousehold5" name="txtHousehold5" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Biological Mother</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiving1" id="chkLiving1" className='add-only' value="Living1" /> Living
                  </td>
                  <td className='w-250'>
                     Frequency of contact:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtLiving1" name="txtLiving1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiving2" id="chkLiving2" className='add-only' value="Living2" /> Deceased
                  </td>
                  <td className='w-250'>
                     Relationship Status:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtLiving2" name="txtLiving2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Biological Father</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiving3" id="chkLiving3" className='add-only' value="Living3" /> Living
                  </td>
                  <td className='w-250'>
                     Frequency of contact:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtLiving3" name="txtLiving3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiving4" id="chkLiving4" className='add-only' value="Living4" /> Deceased
                  </td>
                  <td className='w-250'>
                     Relationship Status:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtLiving4" name="txtLiving4" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Siblings</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiving5" id="chkLiving5" className='add-only' value="Living5" /> Living
                  </td>
                  <td className='w-250'>
                     Frequency of contact:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtLiving5" name="txtLiving5" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiving6" id="chkLiving6" className='add-only' value="Living6" /> Deceased
                  </td>
                  <td className='w-250'>
                     Relationship Status:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtLiving6" name="txtLiving6" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Close Family Members</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiving7" id="chkLiving7" className='add-only' value="Living7" /> Living
                  </td>
                  <td className='w-250'>
                     Frequency of contact:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtLiving7" name="txtLiving7" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLiving8" id="chkLiving8" className='add-only' value="Living8" /> Deceased
                  </td>
                  <td className='w-250'>
                     Relationship Status:
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtLiving8" name="txtLiving8" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Marital Status of biological parents during childhood</span>
               <input type="radio" id="rbMarried_Yes" name="rbMarried" className='add-only' value="1" /> Married
               <input type="radio" id="rbMarried_No" name="rbMarried" className='add-only' value="0" /> Unmarried
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Parenting style of parents</span>
               <textarea id="txtParenting1" name="txtParenting1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Parental history of Domestic Violence</span>
               <textarea id="txtParenting2" name="txtParenting2" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Family ability/willingness to participate in treatment</span>
               <textarea id="txtParenting3" name="txtParenting3" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>How supportive will the client's family and friends be towards client being treated for mental illness or substance abuse</span>
               <textarea id="txtParenting4" name="txtParenting4" className='add-only'></textarea>
            </p>
            <h3>
               Social Environmental Factors (Youth Clients Only)
            </h3>
            <p className='w-750'>
               Youth Client Only
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Does the youth have children</span>
               <input type="radio" id="rbChildren_Yes" name="rbChildren" className='add-only' value="1" /> Yes
               <input type="radio" id="rbChildren_No" name="rbChildren" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               If Yes, how many children? Ages of children <input type="text" id="txtAges" name="txtAges" className='add-only' />
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Describe youth's client's current housing situation</span>
               <input type="radio" id="rbChildren1_Yes" name="rbChildren1" className='add-only' value="1" /> Stable
               <input type="radio" id="rbChildren1_No" name="rbChildren1" className='add-only' value="0" /> Unstable and at risk of Out Home Placement or
               homelessness
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtParentingDetails" name="txtParentingDetails" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Who raised the youth?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbYouth_Yes" name="rbYouth" className='add-only' value="1" /> Parents
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbYouth_No" name="rbYouth" className='add-only' value="0" /> Foster Parents
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbYouth_Nq" name="rbYouth" className='add-only' value="2" /> Other: Adoptive Parent
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbYouth_Nw" name="rbYouth" className='add-only' value="3" /> Grandparents
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbYouth_Nr" name="rbYouth" className='add-only' value="4" /> Aunt/Uncle
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Has youth ever been removed from the home</span>
               <input type="radio" id="rbChildren2_Yes" name="rbChildren2" className='add-only' value="1" /> Yes
               <input type="radio" id="rbChildren2_No" name="rbChildren2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Name and relationship of person/guardian client was placed with: <input type="text" id="txtGuardian" name="txtGuardian" className='add-only' />
            </p>
            <p className='w-750'>
               Length of time youth was out of the home <input type="text" id="txtGuardian1" name="txtGuardian1" className='add-only' />
            </p>
            <h3>
               EMPLOYMENT-VOCATIONAL
            </h3>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Currently Employed</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed_Yes" name="rbEmployed" className='add-only' value="1" /> Yes
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed_No" name="rbEmployed" className='add-only' value="0" /> No
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed_Nq" name="rbEmployed" className='add-only' value="2" /> Full-Time Student
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed_Nw" name="rbEmployed" className='add-only' value="3" /> Disabled
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed_Nr" name="rbEmployed" className='add-only' value="4" /> Not in the work force
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbEmployed_Nn" name="rbEmployed" className='add-only' value="5" /> Other:
                     <input type="text" id="txtEmployed" name="txtEmployed" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Employment Status</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed1_Yes" name="rbEmployed1" className='add-only' value="1" /> Part-Time
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed1_No" name="rbEmployed1" className='add-only' value="0" /> Full-Time
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed1_Nq" name="rbEmployed1" className='add-only' value="2" /> Multiple Jobs
                  </td>
               </tr>
               <tr>
                  <td className='w-500'>
                     <input type="radio" id="rbEmployed1_Nw" name="rbEmployed1" className='add-only' value="3" /> Employed Since
                     <input type="text" id="txtEmployedSince" name="txtEmployedSince" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed1_Nr" name="rbEmployed1" className='add-only' value="4" /> Number of jobs in past 3 years
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Employment Satsifcation</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed4_Yes" name="rbEmployed4" className='add-only' value="1" /> Satisfied with job
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed4_No" name="rbEmployed4" className='add-only' value="0" /> Dissatisfied with job
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbEmployed4_Nq" name="rbEmployed4" className='add-only' value="2" /> Reasons for recent job changes
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbEmployed4_Nw" name="rbEmployed4" className='add-only' value="3" /> Barriers to improving current situation
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>SSDI Eligible?</span>
               <input type="radio" id="rbEligible_Yes" name="rbEligible" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEligible_No" name="rbEligible" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Status of SSDI Claim</span>
               <textarea id="txtStatus" name="txtStatus" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Military Experience</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbMilitary_Yes" name="rbMilitary" className='add-only' value="1" /> Yes
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbMilitary_No" name="rbMilitary" className='add-only' value="0" /> No
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbMilitary_Nq" name="rbMilitary" className='add-only' value="2" /> Discharged due to Disability
                  </td>
               </tr>
            </table>
            <h3>
               DEVELOPMENTAL/PRENATAL AND/OR DELIVERY COMPLICATIONS
            </h3>
            <p className='w-750'>
               <span className='eleHeader'>Full Term Baby</span>
               <input type="radio" id="rbFullTerm1_Yes" name="rbFullTerm1" className='add-only' value="1" /> Yes
               <input type="radio" id="rbFullTerm1_No" name="rbFullTerm1" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtFullTerm1" name="txtFullTerm1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Complications with Pregnancy</span>
               <input type="radio" id="rbFullTerm2_Yes" name="rbFullTerm2" className='add-only' value="1" /> Yes
               <input type="radio" id="rbFullTerm2_No" name="rbFullTerm2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtFullTerm2" name="txtFullTerm2" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Mother: Drug use while pregnant</span>
               <input type="radio" id="rbFullTerm3_Yes" name="rbFullTerm3" className='add-only' value="1" /> Yes
               <input type="radio" id="rbFullTerm3_No" name="rbFullTerm3" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtFullTerm3" name="txtFullTerm3" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Father/Partner supportive during pregnancy</span>
               <input type="radio" id="rbFullTerm4_Yes" name="rbFullTerm4" className='add-only' value="1" /> Yes
               <input type="radio" id="rbFullTerm4_No" name="rbFullTerm4" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtFullTerm4" name="txtFullTerm4" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Complications with delivery</span>
               <input type="radio" id="rbFullTerm5_Yes" name="rbFullTerm5" className='add-only' value="1" /> Yes
               <input type="radio" id="rbFullTerm5_No" name="rbFullTerm5" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtFullTerm5" name="txtFullTerm5" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Illnesses or complications during infancy</span>
               <input type="radio" id="rbFullTerm6_Yes" name="rbFullTerm6" className='add-only' value="1" /> Yes
               <input type="radio" id="rbFullTerm6_No" name="rbFullTerm6" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtFullTerm6" name="txtFullTerm6" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Developmental Milestones met on time</span>
               <input type="radio" id="rbFullTerm7_Yes" name="rbFullTerm7" className='add-only' value="1" /> Yes
               <input type="radio" id="rbFullTerm7_No" name="rbFullTerm7" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtFullTerm7" name="txtFullTerm7" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Early language concerns</span>
               <input type="radio" id="rbFullTerm8_Yes" name="rbFullTerm8" className='add-only' value="1" /> Yes
               <input type="radio" id="rbFullTerm8_No" name="rbFullTerm8" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtFullTerm8" name="txtFullTerm8" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Early temperament concerns</span>
               <input type="radio" id="rbFullTerm9_Yes" name="rbFullTerm9" className='add-only' value="1" /> Yes
               <input type="radio" id="rbFullTerm9_No" name="rbFullTerm9" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtFullTerm9" name="txtFullTerm9" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Need for developmental therapy</span>
               <input type="radio" id="rbFullTerm11_Yes" name="rbFullTerm11" className='add-only' value="1" /> Yes
               <input type="radio" id="rbFullTerm11_No" name="rbFullTerm11" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details:<br />
               <textarea id="txtFullTerm11" name="txtFullTerm11" className='add-only'></textarea>
            </p>
            <h3>
               MEDICAL HISTORY
            </h3>
            <table>
               <tr>
                  <td className='w-200'>
                     <span className='eleHeader'>Diagnosed Illness</span>
                     <input type="text" id="txtDiagnosed" name="txtDiagnosed" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <span className='eleHeader'>Symptoms</span>
                     <input type="text" id="txtSymptoms" name="txtSymptoms" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Treatment and Response</span>
                     <input type="text" id="txtTreatmentResponse" name="txtTreatmentResponse" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <span className='eleHeader'>Barriers to Recovery</span>
                     <input type="text" id="txtBarriers" name="txtBarriers" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="text" id="txtDiagnosed2" name="txtDiagnosed2" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtSymptoms2" name="txtSymptoms2" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtTreatmentResponse2" name="txtTreatmentResponse2" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtBarriers2" name="txtBarriers2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="text" id="txtDiagnosed3" name="txtDiagnosed3" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtSymptoms3" name="txtSymptoms3" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtTreatmentResponse3" name="txtTreatmentResponse3" className='add-only' />
                  </td>
                  <td className='w-200'>
                     <input type="text" id="txtBarriers3" name="txtBarriers3" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Notes/Concerns:</span>
               <textarea id="txtConcerns" name="txtConcerns" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Allergies</span>
               <input type="radio" id="rbEnuresis1_Yes" name="rbEnuresis1" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis1_No" name="rbEnuresis1" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis1" name="txtEnuresis1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Enuresis</span>
               <input type="radio" id="rbEnuresis2_Yes" name="rbEnuresis2" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis2_No" name="rbEnuresis2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis2" name="txtEnuresis2" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Encopresis</span>
               <input type="radio" id="rbEnuresis3_Yes" name="rbEnuresis3" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis3_No" name="rbEnuresis3" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis3" name="txtEnuresis3" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Vision Complications</span>
               <input type="radio" id="rbEnuresis4_Yes" name="rbEnuresis4" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis4_No" name="rbEnuresis4" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis4" name="txtEnuresis4" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Hearing Complications</span>
               <input type="radio" id="rbEnuresis5_Yes" name="rbEnuresis5" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis5_No" name="rbEnuresis5" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis5" name="txtEnuresis5" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Speech Complications</span>
               <input type="radio" id="rbEnuresis6_Yes" name="rbEnuresis6" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis6_No" name="rbEnuresis6" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis6" name="txtEnuresis6" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Dental Complications</span>
               <input type="radio" id="rbEnuresis7_Yes" name="rbEnuresis7" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis7_No" name="rbEnuresis7" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis7" name="txtEnuresis7" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Skin Complications</span>
               <input type="radio" id="rbEnuresis8_Yes" name="rbEnuresis8" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis8_No" name="rbEnuresis8" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis8" name="txtEnuresis8" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Diet Restrictions</span>
               <input type="radio" id="rbEnuresis9_Yes" name="rbEnuresis9" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis9_No" name="rbEnuresis9" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis9" name="txtEnuresis9" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Seizures</span>
               <input type="radio" id="rbEnuresis10_Yes" name="rbEnuresis10" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis10_No" name="rbEnuresis10" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis10" name="txtEnuresis10" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Heart/Blood Pressure</span>
               <input type="radio" id="rbEnuresis11_Yes" name="rbEnuresis11" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis11_No" name="rbEnuresis11" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis11" name="txtEnuresis11" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Diabetes</span>
               <input type="radio" id="rbEnuresis12_Yes" name="rbEnuresis12" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis12_No" name="rbEnuresis12" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis12" name="txtEnuresis12" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Problems Eating</span>
               <input type="radio" id="rbEnuresis13_Yes" name="rbEnuresis13" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis13_No" name="rbEnuresis13" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis" name="txtEnuresis" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Problems Sleeping</span>
               <input type="radio" id="rbEnuresis14_Yes" name="rbEnuresis14" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis14_No" name="rbEnuresis14" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis14" name="txtEnuresis14" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Immunizations Current</span>
               <input type="radio" id="rbEnuresis15_Yes" name="rbEnuresis15" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis15_No" name="rbEnuresis15" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis15" name="txtEnuresis15" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Client Needs Assistive Technology</span>
               <input type="radio" id="rbEnuresis16_Yes" name="rbEnuresis16" className='add-only' value="1" /> Yes
               <input type="radio" id="rbEnuresis16_No" name="rbEnuresis16" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis16" name="txtEnuresis16" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Date of Last Physical</span>
               Date:<input type="date" id="txtPhysicalDate" name="txtPhysicalDate" className='add-only' />
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresis17" name="txtEnuresis17" className='add-only'></textarea>
            </p>
            <h4>
               Physical Stature
            </h4>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Approximate Height:</span>
                     <input type="text" id="txtHeight" name="txtHeight" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Approximate Weight:</span>
                     <input type="text" id="txtWeight" name="txtWeight" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Primary Care Physician</span>
               <textarea id="txtPhysician" name="txtPhysician" className='add-only'></textarea>
            </p>
            <h3>
               CURRENT MEDICATIONS <span className='small'>(All medications)</span>
            </h3>
            <table>
               <tr>
                  <td className='w-150'>
                     <span className='eleHeader'>Name</span>
                     <input type="text" id="txtNameHousehold" name="txtNameHousehold" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <span className='eleHeader'>Dosage/Freq.</span>
                     <input type="text" id="txtDosageFreq" name="txtDosageFreq" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Date prescribed</span>
                     <input type="date" id="txtDatePrescribed" name="txtDatePrescribed" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Prescribed by</span>
                     <input type="text" id="txtPrescribed" name="txtPrescribed" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Outcome/Compliance</span>
                     <input type="text" id="txtOutcomeCompliance" name="txtOutcomeCompliance" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtNameHousehold2" name="txtNameHousehold2" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtDosageFreq2" name="txtDosageFreq2" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDatePrescribed2" name="txtDatePrescribed2" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtPrescribed2" name="txtPrescribed2" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeCompliance2" name="txtOutcomeCompliance2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtNameHousehold3" name="txtNameHousehold3" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtDosageFreq3" name="txtDosageFreq3" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDatePrescribed3" name="txtDatePrescribed3" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtPrescribed3" name="txtPrescribed3" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeCompliance3" name="txtOutcomeCompliance3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtNameHousehold4" name="txtNameHousehold4" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtDosageFreq4" name="txtDosageFreq4" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDatePrescribed4" name="txtDatePrescribed4" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtPrescribed4" name="txtPrescribed4" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeCompliance4" name="txtOutcomeCompliance4" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Note any side effects reported:</span>
               <textarea id="txtAchievingNote" name="txtAchievingNote" className='add-only'></textarea>
            </p>
            <h3>
               HISTORY OF MEDICATIONS
            </h3>
            <table>
               <tr>
                  <td className='w-150'>
                     <span className='eleHeader'>Name</span>
                     <input type="text" id="txtNameHousehold5" name="txtNameHousehold5" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <span className='eleHeader'>Dosage</span>
                     <input type="text" id="txtDosageFreq5" name="txtDosageFreq5" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Date prescribed</span>
                     <input type="date" id="txtDatePrescribed5" name="txtDatePrescribed5" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Prescribed by</span>
                     <input type="text" id="txtPrescribed5" name="txtPrescribed5" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Outcome/Compliance</span>
                     <input type="text" id="txtOutcomeCompliance5" name="txtOutcomeCompliance5" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtNameHousehold6" name="txtNameHousehold6" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtDosageFreq6" name="txtDosageFreq6" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDatePrescribed6" name="txtDatePrescribed6" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtPrescribed6" name="txtPrescribed6" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeCompliance6" name="txtOutcomeCompliance6" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtNameHousehold7" name="txtNameHousehold7" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtDosageFreq7" name="txtDosageFreq7" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDatePrescribed7" name="txtDatePrescribed7" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtPrescribed7" name="txtPrescribed7" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeCompliance7" name="txtOutcomeCompliance7" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="text" id="txtNameHousehold8" name="txtNameHousehold8" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtDosageFreq8" name="txtDosageFreq8" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDatePrescribed8" name="txtDatePrescribed8" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtPrescribed8" name="txtPrescribed8" className='add-only' />
                  </td>
                  <td className='w-150'>
                     <input type="text" id="txtOutcomeCompliance8" name="txtOutcomeCompliance8" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Note any Side Effects or Allergies reported:</span>
               <textarea id="txtAchievingNote1" name="txtAchievingNote1" className='add-only'></textarea>
            </p>
            <h3>
               SUBSTANCE USE AND ADDICTION INFORMATION
            </h3>
            <p className='w-750'>
               <input type="checkbox" name="chkReported" id="chkReported" className='add-only' value="Reported" /> No substance use reported/Denies all substance use
            </p>


            <table>
               <tr>
                  <td className='w-100'>
                     <span className='eleHeader'>Substance Name</span>
                     Tobacco
                  </td>
                  <td className='w-100'>
                     <span className='eleHeader'>Age First Used</span>
                     <input type="text" id="txtAgeFirstUsed1" name="txtAgeFirstUsed1" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <span className='eleHeader'>Route</span>
                     <input type="checkbox" name="chkOral1" id="chkOral1" className='add-only' value="Oral1" /> Oral <br />
                     <input type="checkbox" name="chkSmoking1" id="chkSmoking1" className='add-only' value="Smoking1" /> Smoking <br />
                     <input type="checkbox" name="chkInhale1" id="chkInhale1" className='add-only' value="Inhale1" /> Inhale <br />
                     <input type="checkbox" name="chkInject1" id="chkInject1" className='add-only' value="Inject1" /> Inject <br />
                     <input type="checkbox" name="chkOther1" id="chkOther1" className='add-only' value="Other1" /> Other
                  </td>
                  <td className='w-100'>
                     <span className='eleHeader'>Frequency</span>
                     <input type="checkbox" name="chkPastMonth1" id="chkPastMonth1" className='add-only' value="PastMonth1" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth1" id="chkXpastMonth1" className='add-only' value="XpastMonth1" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth1" id="chkPastWeekMonth1" className='add-only' value="PastWeekMonth1" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth1" id="chkPastWeMonth1" className='add-only' value="PastWeMonth1" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily1" id="chkPastMonthDaily1" className='add-only' value="PastMonthDaily1" /> Daily
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Date of last use</span>
                     <input type="date" id="txtDateLastUse1" name="txtDateLastUse1" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <span className='eleHeader'>Average use</span>
                     <input type="text" id="txtAverageUse1" name="txtAverageUse1" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <span className='eleHeader'>Order of Choice </span><span className='small'>(1,2,3)</span>
                     <input type="text" id="txtOrderChoice1" name="txtOrderChoice1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Alcohol
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed2" name="txtAgeFirstUsed2" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral2" id="chkOral2" className='add-only' value="Oral2" /> Oral <br />
                     <input type="checkbox" name="chkSmoking2" id="chkSmoking2" className='add-only' value="Smoking2" /> Smoking <br />
                     <input type="checkbox" name="chkInhale2" id="chkInhale2" className='add-only' value="Inhale2" /> Inhale <br />
                     <input type="checkbox" name="chkInject2" id="chkInject2" className='add-only' value="Inject2" /> Inject <br />
                     <input type="checkbox" name="chkOther2" id="chkOther2" className='add-only' value="Other2" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth2" id="chkPastMonth2" className='add-only' value="PastMonth2" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth2" id="chkXpastMonth2" className='add-only' value="XpastMonth2" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth2" id="chkPastWeekMonth2" className='add-only' value="PastWeekMonth2" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth2" id="chkPastWeMonth2" className='add-only' value="PastWeMonth2" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily2" id="chkPastMonthDaily2" className='add-only' value="PastMonthDaily2" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse2" name="txtDateLastUse2" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse2" name="txtAverageUse2" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice2" name="txtOrderChoice2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Marijuana
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed3" name="txtAgeFirstUsed3" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral3" id="chkOral3" className='add-only' value="Oral3" /> Oral <br />
                     <input type="checkbox" name="chkSmoking3" id="chkSmoking3" className='add-only' value="Smoking3" /> Smoking <br />
                     <input type="checkbox" name="chkInhale3" id="chkInhale3" className='add-only' value="Inhale3" /> Inhale <br />
                     <input type="checkbox" name="chkInject3" id="chkInject3" className='add-only' value="Inject3" /> Inject <br />
                     <input type="checkbox" name="chkOther3" id="chkOther3" className='add-only' value="Other3" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth3" id="chkPastMonth3" className='add-only' value="PastMonth3" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth3" id="chkXpastMonth3" className='add-only' value="XpastMonth3" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth3" id="chkPastWeekMonth3" className='add-only' value="PastWeekMonth3" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth3" id="chkPastWeMonth3" className='add-only' value="PastWeMonth3" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily3" id="chkPastMonthDaily3" className='add-only' value="PastMonthDaily3" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse3" name="txtDateLastUse3" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse3" name="txtAverageUse3" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice3" name="txtOrderChoice3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Synthetic Marijuana (includes spice, K2)
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed4" name="txtAgeFirstUsed4" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral4" id="chkOral4" className='add-only' value="Oral4" /> Oral <br />
                     <input type="checkbox" name="chkSmoking4" id="chkSmoking4" className='add-only' value="Smoking4" /> Smoking <br />
                     <input type="checkbox" name="chkInhale4" id="chkInhale4" className='add-only' value="Inhale4" /> Inhale <br />
                     <input type="checkbox" name="chkInject4" id="chkInject4" className='add-only' value="Inject4" /> Inject <br />
                     <input type="checkbox" name="chkOther4" id="chkOther4" className='add-only' value="Other4" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth4" id="chkPastMonth4" className='add-only' value="PastMonth4" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth4" id="chkXpastMonth4" className='add-only' value="XpastMonth4" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth4" id="chkPastWeekMonth4" className='add-only' value="PastWeekMonth4" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth4" id="chkPastWeMonth4" className='add-only' value="PastWeMonth4" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily4" id="chkPastMonthDaily4" className='add-only' value="PastMonthDaily4" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse4" name="txtDateLastUse4" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse4" name="txtAverageUse4" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice4" name="txtOrderChoice4" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Inhalants
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed5" name="txtAgeFirstUsed5" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral5" id="chkOral5" className='add-only' value="Oral5" /> Oral <br />
                     <input type="checkbox" name="chkSmoking5" id="chkSmoking5" className='add-only' value="Smoking5" /> Smoking <br />
                     <input type="checkbox" name="chkInhale5" id="chkInhale5" className='add-only' value="Inhale5" /> Inhale <br />
                     <input type="checkbox" name="chkInject5" id="chkInject5" className='add-only' value="Inject5" /> Inject <br />
                     <input type="checkbox" name="chkOther5" id="chkOther5" className='add-only' value="Other5" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth5" id="chkPastMonth5" className='add-only' value="PastMonth5" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth5" id="chkXpastMonth5" className='add-only' value="XpastMonth5" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth5" id="chkPastWeekMonth5" className='add-only' value="PastWeekMonth5" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth5" id="chkPastWeMonth5" className='add-only' value="PastWeMonth5" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily5" id="chkPastMonthDaily5" className='add-only' value="PastMonthDaily5" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse5" name="txtDateLastUse5" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse5" name="txtAverageUse5" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice5" name="txtOrderChoice5" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Crack/Cocaine
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed6" name="txtAgeFirstUsed6" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral6" id="chkOral6" className='add-only' value="Oral6" /> Oral <br />
                     <input type="checkbox" name="chkSmoking6" id="chkSmoking6" className='add-only' value="Smoking6" /> Smoking <br />
                     <input type="checkbox" name="chkInhale6" id="chkInhale6" className='add-only' value="Inhale6" /> Inhale <br />
                     <input type="checkbox" name="chkInject6" id="chkInject6" className='add-only' value="Inject6" /> Inject <br />
                     <input type="checkbox" name="chkOther6" id="chkOther6" className='add-only' value="Other6" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth6" id="chkPastMonth6" className='add-only' value="PastMonth6" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth6" id="chkXpastMonth6" className='add-only' value="XpastMonth6" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth6" id="chkPastWeekMonth6" className='add-only' value="PastWeekMonth6" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth6" id="chkPastWeMonth6" className='add-only' value="PastWeMonth6" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily6" id="chkPastMonthDaily6" className='add-only' value="PastMonthDaily6" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse6" name="txtDateLastUse6" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse6" name="txtAverageUse6" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice6" name="txtOrderChoice6" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Heroin/Opioids
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed7" name="txtAgeFirstUsed7" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral7" id="chkOral7" className='add-only' value="Oral7" /> Oral <br />
                     <input type="checkbox" name="chkSmoking7" id="chkSmoking7" className='add-only' value="Smoking7" /> Smoking <br />
                     <input type="checkbox" name="chkInhale7" id="chkInhale7" className='add-only' value="Inhale7" /> Inhale <br />
                     <input type="checkbox" name="chkInject7" id="chkInject7" className='add-only' value="Inject7" /> Inject <br />
                     <input type="checkbox" name="chkOther7" id="chkOther7" className='add-only' value="Other7" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth8" id="chkPastMonth8" className='add-only' value="PastMonth8" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth8" id="chkXpastMonth8" className='add-only' value="XpastMonth8" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth8" id="chkPastWeekMonth8" className='add-only' value="PastWeekMonth8" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth8" id="chkPastWeMonth8" className='add-only' value="PastWeMonth8" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily8" id="chkPastMonthDaily8" className='add-only' value="PastMonthDaily8" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse8" name="txtDateLastUse8" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse8" name="txtAverageUse8" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice8" name="txtOrderChoice8" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Ecstasy (MDMA, molly)
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed9" name="txtAgeFirstUsed9" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral9" id="chkOral9" className='add-only' value="Oral9" /> Oral <br />
                     <input type="checkbox" name="chkSmoking9" id="chkSmoking9" className='add-only' value="Smoking9" /> Smoking <br />
                     <input type="checkbox" name="chkInhale9" id="chkInhale9" className='add-only' value="Inhale9" /> Inhale <br />
                     <input type="checkbox" name="chkInject9" id="chkInject9" className='add-only' value="Inject9" /> Inject <br />
                     <input type="checkbox" name="chkOther9" id="chkOther9" className='add-only' value="Other9" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth9" id="chkPastMonth9" className='add-only' value="PastMonth9" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth9" id="chkXpastMonth9" className='add-only' value="XpastMonth9" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth9" id="chkPastWeekMonth9" className='add-only' value="PastWeekMonth9" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth9" id="chkPastWeMonth9" className='add-only' value="PastWeMonth9" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily9" id="chkPastMonthDaily9" className='add-only' value="PastMonthDaily9" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse9" name="txtDateLastUse9" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse9" name="txtAverageUse9" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice9" name="txtOrderChoice9" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Hallucinogens (LSD, PCP, etc.)
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed10" name="txtAgeFirstUsed10" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral10" id="chkOral10" className='add-only' value="Oral10" /> Oral <br />
                     <input type="checkbox" name="chkSmoking10" id="chkSmoking10" className='add-only' value="Smoking10" /> Smoking <br />
                     <input type="checkbox" name="chkInhale10" id="chkInhale10" className='add-only' value="Inhale10" /> Inhale <br />
                     <input type="checkbox" name="chkInject10" id="chkInject10" className='add-only' value="Inject10" /> Inject <br />
                     <input type="checkbox" name="chkOther10" id="chkOther10" className='add-only' value="Other10" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth10" id="chkPastMonth10" className='add-only' value="PastMonth10" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth10" id="chkXpastMonth10" className='add-only' value="XpastMonth10" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth10" id="chkPastWeekMonth10" className='add-only' value="PastWeekMonth10" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth10" id="chkPastWeMonth10" className='add-only' value="PastWeMonth10" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily10" id="chkPastMonthDaily10" className='add-only' value="PastMonthDaily10" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse10" name="txtDateLastUse10" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse10" name="txtAverageUse10" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice10" name="txtOrderChoice10" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Over the counter (purple drink etc.)
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed11" name="txtAgeFirstUsed11" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral11" id="chkOral11" className='add-only' value="Oral11" /> Oral <br />
                     <input type="checkbox" name="chkSmoking11" id="chkSmoking11" className='add-only' value="Smoking11" /> Smoking <br />
                     <input type="checkbox" name="chkInhale11" id="chkInhale11" className='add-only' value="Inhale11" /> Inhale <br />
                     <input type="checkbox" name="chkInject11" id="chkInject11" className='add-only' value="Inject11" /> Inject <br />
                     <input type="checkbox" name="chkOther11" id="chkOther11" className='add-only' value="Other11" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth11" id="chkPastMonth11" className='add-only' value="PastMonth11" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth11" id="chkXpastMonth11" className='add-only' value="XpastMonth11" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth11" id="chkPastWeekMonth11" className='add-only' value="PastWeekMonth11" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth11" id="chkPastWeMonth11" className='add-only' value="PastWeMonth11" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily11" id="chkPastMonthDaily11" className='add-only' value="PastMonthDaily11" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse11" name="txtDateLastUse11" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse11" name="txtAverageUse11" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice11" name="txtOrderChoice11" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Prescription drugs (Anxiety medication etc.)
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed12" name="txtAgeFirstUsed12" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral12" id="chkOral12" className='add-only' value="Oral12" /> Oral <br />
                     <input type="checkbox" name="chkSmoking12" id="chkSmoking12" className='add-only' value="Smoking12" /> Smoking <br />
                     <input type="checkbox" name="chkInhale12" id="chkInhale12" className='add-only' value="Inhale12" /> Inhale <br />
                     <input type="checkbox" name="chkInject12" id="chkInject12" className='add-only' value="Inject12" /> Inject <br />
                     <input type="checkbox" name="chkOther12" id="chkOther12" className='add-only' value="Other12" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth12" id="chkPastMonth12" className='add-only' value="PastMonth12" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth12" id="chkXpastMonth12" className='add-only' value="XpastMonth12" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth12" id="chkPastWeekMonth12" className='add-only' value="PastWeekMonth12" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth12" id="chkPastWeMonth12" className='add-only' value="PastWeMonth12" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily12" id="chkPastMonthDaily12" className='add-only' value="PastMonthDaily12" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse12" name="txtDateLastUse12" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse12" name="txtAverageUse12" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice12" name="txtOrderChoice12" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Stimulants
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed13" name="txtAgeFirstUsed13" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral13" id="chkOral13" className='add-only' value="Oral13" /> Oral <br />
                     <input type="checkbox" name="chkSmoking13" id="chkSmoking13" className='add-only' value="Smoking13" /> Smoking <br />
                     <input type="checkbox" name="chkInhale13" id="chkInhale13" className='add-only' value="Inhale13" /> Inhale <br />
                     <input type="checkbox" name="chkInject13" id="chkInject13" className='add-only' value="Inject13" /> Inject <br />
                     <input type="checkbox" name="chkOther13" id="chkOther13" className='add-only' value="Other13" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth13" id="chkPastMonth13" className='add-only' value="PastMonth13" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth13" id="chkXpastMonth13" className='add-only' value="XpastMonth13" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth13" id="chkPastWeekMonth13" className='add-only' value="PastWeekMonth13" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth13" id="chkPastWeMonth13" className='add-only' value="PastWeMonth13" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily13" id="chkPastMonthDaily13" className='add-only' value="PastMonthDaily13" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse13" name="txtDateLastUse13" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse13" name="txtAverageUse13" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice13" name="txtOrderChoice13" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     Other Drugs
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAgeFirstUsed14" name="txtAgeFirstUsed14" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkOral14" id="chkOral14" className='add-only' value="Oral14" /> Oral <br />
                     <input type="checkbox" name="chkSmoking14" id="chkSmoking14" className='add-only' value="Smoking14" /> Smoking <br />
                     <input type="checkbox" name="chkInhale14" id="chkInhale14" className='add-only' value="Inhale14" /> Inhale <br />
                     <input type="checkbox" name="chkInject14" id="chkInject14" className='add-only' value="Inject14" /> Inject <br />
                     <input type="checkbox" name="chkOther14" id="chkOther14" className='add-only' value="Other14" /> Other
                  </td>
                  <td className='w-100'>
                     <input type="checkbox" name="chkPastMonth14" id="chkPastMonth14" className='add-only' value="PastMonth14" /> No use past month <br />
                     <input type="checkbox" name="chkXpastMonth14" id="chkXpastMonth14" className='add-only' value="XpastMonth14" /> 1-3x/past month<br />
                     <input type="checkbox" name="chkPastWeekMonth14" id="chkPastWeekMonth14" className='add-only' value="PastWeekMonth14" /> 1-2x/week <br />
                     <input type="checkbox" name="chkPastWeMonth14" id="chkPastWeMonth14" className='add-only' value="PastWeMonth14" /> 3-6x/week <br />
                     <input type="checkbox" name="chkPastMonthDaily14" id="chkPastMonthDaily14" className='add-only' value="PastMonthDaily14" /> Daily
                  </td>
                  <td className='w-150'>
                     <input type="date" id="txtDateLastUse14" name="txtDateLastUse14" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtAverageUse14" name="txtAverageUse14" className='add-only' />
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtOrderChoice14" name="txtOrderChoice14" className='add-only' />
                  </td>
               </tr>
            </table>

            <p className='w-750'>
               <span className='eleHeader'>Is there evidence of intoxication during this interview:</span>
               <input type="radio" id="rbInterview_Yes" name="rbInterview" className='add-only' value="1" /> Yes
               <input type="radio" id="rbInterview_No" name="rbInterview" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresisDetails" name="txtEnuresisDetails" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Means of obtaining substance:</span>
               <textarea id="txtMeans" name="txtMeans" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Motivation for use:</span>
               <textarea id="txtMeansMotivation" name="txtMeansMotivation" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Strong desire or urge to use</span>
               <input type="radio" id="rbInterview1_Yes" name="rbInterview1" className='add-only' value="1" /> Yes
               <input type="radio" id="rbInterview1_No" name="rbInterview1" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Interest in reducing use and attaining abstinence:</span>
               <input type="radio" id="rbInterview2_Yes" name="rbInterview2" className='add-only' value="1" /> Yes
               <input type="radio" id="rbInterview2_No" name="rbInterview2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresisDetails1" name="txtEnuresisDetails1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Past periods of abstinence:</span>
               <textarea id="txtMeansMotivation2" name="txtMeansMotivation2" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Problems use may have caused:</span>
               <textarea id="txtMeansMotivation3" name="txtMeansMotivation3" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Any withdrawal symptoms present:</span>
               <textarea id="txtMeansMotivation4" name="txtMeansMotivation4" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Any nonchemical addictions:</span>
               <input type="radio" id="rbInterview4_Yes" name="rbInterview4" className='add-only' value="1" /> Yes
               <input type="radio" id="rbInterview4_No" name="rbInterview4" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               Details<br />
               <textarea id="txtEnuresisDetail2" name="txtEnuresisDetail2" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>When was the last drug screen?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbMilitaryDrug1_Yes" name="rbMilitaryDrug1" className='add-only' value="1" /> Negative
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbMilitaryDrug1_No" name="rbMilitaryDrug1" className='add-only' value="0" /> Positive
                  </td>
                  <td className='w-350'>
                     <input type="radio" id="rbMilitaryDrug1_Nq" name="rbMilitaryDrug1" className='add-only' value="2" /> N/A - Individual has never been screened
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Means of obtaining substances/efforts made to obtain substance?</span>
               <textarea id="txtSubstances1" name="txtSubstances1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Increased amount of use over a longer period than intended?</span>
               <textarea id="txtSubstances2" name="txtSubstances2" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Need for Increase amounts to achieve intoxication or desired effect? Decreased effect using the same amount?</span>
               <textarea id="txtSubstances3" name="txtSubstances3" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Educational/ecological/medical/risk behaviors drug use may have caused?</span>
               <textarea id="txtSubstances4" name="txtSubstances4" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Is the client willing to participate in treatment</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbMilitaryDrug_Yes" name="rbMilitaryDrug" className='add-only' value="1" /> Yes
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbMilitaryDrug_No" name="rbMilitaryDrug" className='add-only' value="0" /> No
                  </td>
                  <td className='w-350'>
                     <input type="radio" id="rbMilitaryDrug_Nq" name="rbMilitaryDrug" className='add-only' value="2" /> No treatment recommended at this time
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'> Other addictive behaviors:</span>
               <textarea id="txtAddictive" name="txtAddictive" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Family history of substance use</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-350'>
                     <input type="radio" id="rbMilitaryDrug21_Yes" name="rbMilitaryDrug21" className='add-only' value="1" /> Yes, describe
                     <input type="text" id="txtMilitaryDrug" name="txtMilitaryDrug" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbMilitaryDrug21_No" name="rbMilitaryDrug21" className='add-only' value="0" /> No
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbMilitaryDrug21_Nq" name="rbMilitaryDrug21" className='add-only' value="2" /> Unknown
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Additional information</span>
               <textarea id="txtAdditional" name="txtAdditional" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Family prepared to support client in substance use treatment</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbMilitaryDrug2_Yes" name="rbMilitaryDrug2" className='add-only' value="1" /> Yes
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbMilitaryDrug2_No" name="rbMilitaryDrug2" className='add-only' value="0" /> No
                  </td>
                  <td className='w-350'>
                     <input type="radio" id="rbMilitaryDrug2_Nq" name="rbMilitaryDrug2" className='add-only' value="2" /> N/A No treatment recommendation
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Additional information</span>
               <textarea id="txtAdditional1" name="txtAdditional1" className='add-only'></textarea>
            </p>
            <h3>
               ASAM Levels of Care  <span className='small'>(Check the appropriate recommended Level of Care)</span>
            </h3>
            <p className='w-750'>
               <input type="checkbox" name="chkReported5" id="chkReported5" className='add-only' value="Reported5" /> <strong> no Sub Use reported</strong>
            </p>
            <table>
               <tr>
                  <td className='w-20'>
                     <input type="radio" id="rbSubLegal_Yes" name="rbSubLegal" className='add-only' value="1" />
                  </td>
                  <td className='w-100'>
                     Level 0.5
                  </td>
                  <td className='w-200'>
                     Outpatient/Drug
                     Education/Early Intervention
                     (OPT)
                  </td>
                  <td className='w-200'>
                     Risk factors or problems, no
                     DSM-5 diagnosis, psycho
                     education monitoring
                  </td>
                  <td className='w-230'>
                     Minimum of two hours weekly
                     of outpatient Therapy and
                     Psychiatry
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     <input type="radio" id="rbSubLegal_No" name="rbSubLegal" className='add-only' value="0" />
                  </td>
                  <td className='w-100'>
                     Level 1
                  </td>
                  <td className='w-200'>
                     Outpatient (OPT)
                  </td>
                  <td className='w-200'>
                     DSM-5 diagnosis
                     Low severity of problems
                     Low intensity outpatient
                  </td>
                  <td className='w-230'>
                     Minimum of four hours (and less
                     than 9 hours weekly) of
                     outpatient therapy and
                     Psychiatry
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     <input type="radio" id="rbSubLegal_Ys" name="rbSubLegal" className='add-only' value="2" />
                  </td>
                  <td className='w-100'>
                     Level 2.1
                  </td>
                  <td className='w-200'>
                     Intensive Outpatient (SAIOP)
                     or SA lead Intensive In-Home
                     Services
                  </td>
                  <td className='w-200'>
                     DSM-5 diagnosis
                     Intensive Outpatient treatment,
                     structured evening program
                  </td>
                  <td className='w-230'>
                     Minimum of nine hours weekly of
                     Substance Abuse Intensive
                     Outpatient (SAIOP) for
                     adults/Minimum of six hours per
                     week for adolescents
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     <input type="radio" id="rbSubLegal_Ye" name="rbSubLegal" className='add-only' value="3" />
                  </td>
                  <td className='w-100'>
                     Level 2.5
                  </td>
                  <td className='w-200'>
                     Day Treatment/Partial
                     Hospitalization/SACOT
                  </td>
                  <td className='w-200'>
                     Clinically Managed structured
                     Day Program
                  </td>
                  <td className='w-230'>
                     Minimum of 8 hours a day, five
                     days per week of SACOT
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     <input type="radio" id="rbSubLegal_Yq" name="rbSubLegal" className='add-only' value="4" />
                  </td>
                  <td className='w-100'>
                     Level 3.1
                  </td>
                  <td className='w-200'>
                     Halfway House/Nonmedical
                     -clinically supervised
                  </td>
                  <td className='w-200'>
                     Clinically Managed structured
                     Residential setting
                  </td>
                  <td className='w-230'>
                     24 hours per day, flexible length
                     of stay
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     <input type="radio" id="rbSubLegal_Yr" name="rbSubLegal" className='add-only' value="5" />
                  </td>
                  <td className='w-100'>
                     Level 3.3
                  </td>
                  <td className='w-200'>
                     {`Inpatient Residential < 30 days`}
                  </td>
                  <td className='w-200'>
                     Residential treatment, structured
                     therapeutic community
                  </td>
                  <td className='w-230'>
                     24 hours daily, up to 30 days
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     <input type="radio" id="rbSubLegal_Yt" name="rbSubLegal" className='add-only' value="6" />
                  </td>
                  <td className='w-100'>
                     Level 3.5
                  </td>
                  <td className='w-200'>
                     {`Inpatient Residential > 30 days`}
                  </td>
                  <td className='w-200'>
                     Significant problems with living
                     skills, antisocial traits
                  </td>
                  <td className='w-230'>
                     24 hours daily, more than 30
                     days to 6 months
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     <input type="radio" id="rbSubLegal_Yy" name="rbSubLegal" className='add-only' value="7" />
                  </td>
                  <td className='w-100'>
                     Level 3.7
                  </td>
                  <td className='w-200'>
                     Inpatient semi-medically
                     managed or medicallymonitored,
                     severe problems
                     with ASAM Dimension3
                  </td>
                  <td className='w-200'>
                     Withdrawal symptoms or
                     potential severe enough to
                     require 24 hours inpatient
                     monitoring
                  </td>
                  <td className='w-230'>
                     24 hours inpatient, 2-5 days per
                     week
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     <input type="radio" id="rbSubLegal_Yu" name="rbSubLegal" className='add-only' value="8" />
                  </td>
                  <td className='w-100'>
                     Level 4
                  </td>
                  <td className='w-200'>
                     Full Medically Managed
                     Intensive inpatient treatment,
                     hospital setting
                  </td>
                  <td className='w-200'>
                     Withdrawal symptoms or
                     potential severe enough to
                     require inpatient care, physician
                     management, hospitalization
                  </td>
                  <td className='w-230'>
                     24 hours, emergency services,
                     1-5 days.
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     &nbsp;
                  </td>
                  <td className='w-100'>
                     <strong> OR ------ </strong>
                  </td>
                  <td className='w-200'>
                     <strong> Check below if acute detox
                        needed</strong>
                  </td>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-230'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     <input type="radio" id="rbSubLegal_Yo" name="rbSubLegal" className='add-only' value="10" />
                  </td>
                  <td className='w-100'>
                     Withdra
                     wal
                     Manage
                     ment
                     levels 1 -
                     4D (WM)
                  </td>
                  <td className='w-200'>
                     Outpatient or Inpatient
                     Detoxification or Residential/
                     medically supervised/ crisis
                     stabilization ADAT
                  </td>
                  <td className='w-200'>
                     Must have DSM-5 diagnosis:
                     Outpatient or inpatient setting
                     detoxification, may be
                     residential/may be 24 hours/may
                     be inpatient
                  </td>
                  <td className='w-230'>
                     1 to 7 days per week, or 24
                     hours per day, referral to
                     Substance Abuse Specialist
                     facility or agency
                  </td>
               </tr>
            </table>
            <h3>
               PSYCHOLOGICAL DIMENSIONS
            </h3>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkPsychological1" id="chkPsychological1" className='add-only' value="Psychological1" /> <strong>Depression</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological2" id="chkPsychological2" className='add-only' value="Psychological2" /> None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPsychological3" id="chkPsychological3" className='add-only' value="Psychological3" />  Hopelessness
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological4" id="chkPsychological4" className='add-only' value="Psychological4" /> Depressed mood most of the day,
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPsychological5" id="chkPsychological5" className='add-only' value="Psychological5" /> Worthlessness
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     nearly everyday
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPsychological6" id="chkPsychological6" className='add-only' value="Psychological6" />  Difficulty concentrating
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological7" id="chkPsychological7" className='add-only' value="Psychological7" /> Tearfulness
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPsychological8" id="chkPsychological8" className='add-only' value="Psychological8" />  Increase/decrease in appetite
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological9" id="chkPsychological9" className='add-only' value="Psychological9" /> Sleep too much/too little
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPsychological10" id="chkPsychological10" className='add-only' value="Psychological10" /> Change in energy/activity
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological11" id="chkPsychological11" className='add-only' value="Psychological11" /> Irritability
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPsychological12" id="chkPsychological12" className='add-only' value="Psychological12" /> Description (symptoms,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological13" id="chkPsychological13" className='add-only' value="Psychological13" /> Fatigue
                  </td>
                  <td className='w-300'>
                     frequency,duration, environment)
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological14" id="chkPsychological14" className='add-only' value="Psychological14" /> Weight gain/loss
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkMania1" id="chkMania1" className='add-only' value="Mania1" /> <strong>Mania</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMania2" id="chkMania2" className='add-only' value="Mania2" /> None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkMania3" id="chkMania3" className='add-only' value="Mania3" />  Overconfidence
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMania4" id="chkMania4" className='add-only' value="Mania4" /> Increased energy
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkMania5" id="chkMania5" className='add-only' value="Mania5" />  Recklessness
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMania6" id="chkMania6" className='add-only' value="Mania6" /> Irritability
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkMania7" id="chkMania7" className='add-only' value="Mania7" />  Change in activity
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMania8" id="chkMania8" className='add-only' value="Mania8" /> Racing thoughts
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkMania9" id="chkMania9" className='add-only' value="Mania9" />  Description (symptoms,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMania10" id="chkMania10" className='add-only' value="Mania10" /> Euphoria
                  </td>
                  <td className='w-300'>
                     frequency, duration, environment)
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkDisruptive1" id="chkDisruptive1" className='add-only' value="Disruptive1" /> <strong>Disruptive Mood</strong>
                  </td>
                  <td className='w-175'>
                     <input type="checkbox" name="chkDisruptive2" id="chkDisruptive2" className='add-only' value="Disruptive2" /> None reported
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkDisruptive3" id="chkDisruptive3" className='add-only' value="Disruptive3" />  Temper outbursts 3 or more times per week
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-175'>
                     <input type="checkbox" name="chkDisruptive4" id="chkDisruptive4" className='add-only' value="Disruptive4" /> Irritable almost daily
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkDisruptive5" id="chkDisruptive5" className='add-only' value="Disruptive5" />  Description(symptoms,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-175'>
                     &nbsp;
                  </td>
                  <td className='w-375'>
                     frequency,duration, environment)
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkAnxiety1" id="chkAnxiety1" className='add-only' value="Anxiety1" /> <strong>Anxiety</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAnxiety2" id="chkAnxiety2" className='add-only' value="Anxiety2" /> None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkAnxiety3" id="chkAnxiety3" className='add-only' value="Anxiety3" />  Sleep disturbance
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAnxiety4" id="chkAnxiety4" className='add-only' value="Anxiety4" /> Restlessness
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkAnxiety5" id="chkAnxiety5" className='add-only' value="Anxiety5" />  Distress when separated from parent
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAnxiety6" id="chkAnxiety6" className='add-only' value="Anxiety6" /> Fatigue
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkAnxiety7" id="chkAnxiety7" className='add-only' value="Anxiety7" />  Specific phobia
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAnxiety8" id="chkAnxiety8" className='add-only' value="Anxiety8" /> Irritability
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkAnxiety9" id="chkAnxiety9" className='add-only' value="Anxiety9" />  Distress in social situations
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAnxiety10" id="chkAnxiety10" className='add-only' value="Anxiety10" /> Tension
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkAnxiety11" id="chkAnxiety11" className='add-only' value="Anxiety11" />  Panic attacks
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAnxiety12" id="chkAnxiety12" className='add-only' value="Anxiety12" /> Worrying
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkAnxiety13" id="chkAnxiety13" className='add-only' value="Anxiety13" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAnxiety14" id="chkAnxiety14" className='add-only' value="Anxiety14" /> Difficulty concentrating
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkObsessions1" id="chkObsessions1" className='add-only' value="Obsessions1" /> <strong>Obsessions</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkObsessions2" id="chkObsessions2" className='add-only' value="Obsessions2" /> None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkObsessions3" id="chkObsessions3" className='add-only' value="Obsessions3" />  Disrupts routine/functioning
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkObsessions4" id="chkObsessions4" className='add-only' value="Obsessions4" /> Recurrent & persistent
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkObsessions5" id="chkObsessions5" className='add-only' value="Obsessions5" />  Good insight
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkObsessions6" id="chkObsessions6" className='add-only' value="Obsessions6" /> thoughts/impulses/images
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkObsessions7" id="chkObsessions7" className='add-only' value="Obsessions7" />  Poor insight
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkObsessions8" id="chkObsessions8" className='add-only' value="Obsessions8" /> Causes anxiety
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkObsessions9" id="chkObsessions9" className='add-only' value="Obsessions9" />  Absent insight/delusional
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkObsessions10" id="chkObsessions10" className='add-only' value="Obsessions10" /> Attempts to suppress/neutralize
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkObsessions11" id="chkObsessions11" className='add-only' value="Obsessions11" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkObsessions12" id="chkObsessions12" className='add-only' value="Obsessions12" /> Intrusive/time consuming
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkCompulsions1" id="chkCompulsions1" className='add-only' value="Compulsions1" /> <strong>Compulsions</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkCompulsions2" id="chkCompulsions2" className='add-only' value="Compulsions2" /> None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkCompulsions3" id="chkCompulsions3" className='add-only' value="Compulsions3" />  Disrupts routine
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkCompulsions4" id="chkCompulsions4" className='add-only' value="Compulsions4" /> Repeated behaviors/mental acts
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkCompulsions5" id="chkCompulsions5" className='add-only' value="Compulsions5" />  Good insight
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkCompulsions6" id="chkCompulsions6" className='add-only' value="Compulsions6" /> Driven to perform behaviors
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkCompulsions7" id="chkCompulsions7" className='add-only' value="Compulsions7" />  Poor insight
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkCompulsions8" id="chkCompulsions8" className='add-only' value="Compulsions8" /> Intended to reduce stress
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkCompulsions9" id="chkCompulsions9" className='add-only' value="Compulsions9" />  Absent insight
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkCompulsions10" id="chkCompulsions10" className='add-only' value="Compulsions10" /> Not connected to stressor
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkCompulsions11" id="chkCompulsions11" className='add-only' value="Compulsions11" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkCompulsions12" id="chkCompulsions12" className='add-only' value="Compulsions12" /> Intrusive/time consuming
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkFeeding1" id="chkFeeding1" className='add-only' value="Feeding1" /> <strong>Feeding and Eating</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkFeeding2" id="chkFeeding2" className='add-only' value="Feeding2" /> None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkFeeding3" id="chkFeeding3" className='add-only' value="Feeding3" />  Significantly low body weight
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkFeeding4" id="chkFeeding4" className='add-only' value="Feeding4" /> Persistent eating of nonnutritive,
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkFeeding5" id="chkFeeding5" className='add-only' value="Feeding5" />  Intense fear of gaining weight
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     non-food substances
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkFeeding6" id="chkFeeding6" className='add-only' value="Feeding6" />  Recurrent episodes of binge-eating
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkFeeding7" id="chkFeeding7" className='add-only' value="Feeding7" /> Eating or food disturbance
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkFeeding8" id="chkFeeding8" className='add-only' value="Feeding8" />  Recurrent inappropriate behaviors to
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkFeeding9" id="chkFeeding9" className='add-only' value="Feeding9" /> Significant weight loss
                  </td>
                  <td className='w-300'>
                     prevent weight gain
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkFeeding10" id="chkFeeding10" className='add-only' value="Feeding10" /> Dependence on oral nutritional
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkFeeding11" id="chkFeeding11" className='add-only' value="Feeding11" /> Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     supplements
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkPsychosis1" id="chkPsychosis1" className='add-only' value="Psychosis1" /> <strong>Psychosis</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychosis2" id="chkPsychosis2" className='add-only' value="Psychosis2" /> None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPsychosis3" id="chkPsychosis3" className='add-only' value="Psychosis3" />  Grossly disorganized or catatonic behavior
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychosis4" id="chkPsychosis4" className='add-only' value="Psychosis4" /> Delusions
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPsychosis5" id="chkPsychosis5" className='add-only' value="Psychosis5" />  Affect flattening/alogia/avolition
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychosis6" id="chkPsychosis6" className='add-only' value="Psychosis6" /> Hallucinations
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPsychosis7" id="chkPsychosis7" className='add-only' value="Psychosis7" />  Negative symptoms
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychosis8" id="chkPsychosis8" className='add-only' value="Psychosis8" /> Grossly disorganized speech
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPsychosis9" id="chkPsychosis9" className='add-only' value="Psychosis9" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkGuilt1" id="chkGuilt1" className='add-only' value="Guilt1" /> <strong>Trauma</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt2" id="chkGuilt2" className='add-only' value="Guilt2" /> None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt3" id="chkGuilt3" className='add-only' value="Guilt3" />  Guilt/shame
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt4" id="chkGuilt4" className='add-only' value="Guilt4" /> Experiencing/witnessing hearing
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt5" id="chkGuilt5" className='add-only' value="Guilt5" />  Low interest in activities
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     traumatic event
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt6" id="chkGuilt6" className='add-only' value="Guilt6" />  Detachment from others
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt7" id="chkGuilt7" className='add-only' value="Guilt7" /> Intrusive
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt8" id="chkGuilt8" className='add-only' value="Guilt8" />  Difficulty feeling positive emotions
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     thoughts/reminders/triggers
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt9" id="chkGuilt9" className='add-only' value="Guilt9" />  Irritability/anger
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt10" id="chkGuilt10" className='add-only' value="Guilt10" /> Nightmares
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt11" id="chkGuilt11" className='add-only' value="Guilt11" />  Reckless behavior
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt12" id="chkGuilt12" className='add-only' value="Guilt12" /> Flashbacks
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt13" id="chkGuilt13" className='add-only' value="Guilt13" />  Flashbacks
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt14" id="chkGuilt14" className='add-only' value="Guilt14" /> Re-experiencing of traumatic
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt15" id="chkGuilt15" className='add-only' value="Guilt15" />  Exaggerated startle response
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     event
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt16" id="chkGuilt16" className='add-only' value="Guilt16" /> Difficulty concentrating
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt17" id="chkGuilt17" className='add-only' value="Guilt17" /> Physiological reactions to
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt18" id="chkGuilt18" className='add-only' value="Guilt18" />  Difficulty staying/falling asleep
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     triggers
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt19" id="chkGuilt19" className='add-only' value="Guilt19" />  Feeling detached from one's body
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt20" id="chkGuilt20" className='add-only' value="Guilt20" />  Avoids distressing memories
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt21" id="chkGuilt21" className='add-only' value="Guilt21" />  Feeling like experiences are not real
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt22" id="chkGuilt22" className='add-only' value="Guilt22" />  Avoids reminders of event
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkGuilt23" id="chkGuilt23" className='add-only' value="Guilt23" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt24" id="chkGuilt24" className='add-only' value="Guilt24" />  Difficulty remembering details of
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     the trauma
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt25" id="chkGuilt25" className='add-only' value="Guilt25" />  Negative beliefs about self,
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-200'> &nbsp; </td>
                  <td className='w-250'> others, or of the world </td>
                  <td className='w-300'> &nbsp; </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt26" id="chkGuilt26" className='add-only' value="Guilt26" />  Distorted cognitions about the
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     cause or consequences of the
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     trauma
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGuilt27" id="chkGuilt27" className='add-only' value="Guilt27" />  Negative affect/emotions
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkTrauma1" id="chkTrauma1" className='add-only' value="Trauma1" /> <strong> Other Trauma</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkTrauma2" id="chkTrauma2" className='add-only' value="Trauma2" /> None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkTrauma3" id="chkTrauma3" className='add-only' value="Trauma3" />  Affectionate with unfamiliar adults
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkTrauma4" id="chkTrauma4" className='add-only' value="Trauma4" />  Emotionally withdrawn from
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkTrauma5" id="chkTrauma5" className='add-only' value="Trauma5" />  Social neglect/lack of emotional
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     caregiver
                  </td>
                  <td className='w-300'>
                     needs from caregiver
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkTrauma6" id="chkTrauma6" className='add-only' value="Trauma6" />  Low positive affect
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkTrauma7" id="chkTrauma7" className='add-only' value="Trauma7" />  Sexual reactivity or inappropriate sexual
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkTrauma8" id="chkTrauma8" className='add-only' value="Trauma8" />  Unstable relationships with
                  </td>
                  <td className='w-300'>
                     behaviors
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     caregivers
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkTrauma9" id="chkTrauma9" className='add-only' value="Trauma9" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkInattention1" id="chkInattention1" className='add-only' value="Inattention1" />  <strong>Inattention</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInattention2" id="chkInattention2" className='add-only' value="Inattention2" />  None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkInattention3" id="chkInattention3" className='add-only' value="Inattention3" />  Forgetful in daily activities
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInattention4" id="chkInattention4" className='add-only' value="Inattention4" />  Fails to pay attention/makes
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkInattention5" id="chkInattention5" className='add-only' value="Inattention5" />  Loses things
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     careless mistakes
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkInattention6" id="chkInattention6" className='add-only' value="Inattention6" /> Avoids/dislikes activities that require focus
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInattention7" id="chkInattention7" className='add-only' value="Inattention7" />  Disorganized
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkInattention8" id="chkInattention8" className='add-only' value="Inattention8" />  Symptoms before age 12
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInattention9" id="chkInattention9" className='add-only' value="Inattention9" />  Easily distracted
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkInattention10" id="chkInattention10" className='add-only' value="Inattention10" />  Symptoms present in 2 or more settings
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInattention11" id="chkInattention11" className='add-only' value="Inattention11" />  Does not seem to listen
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkInattention12" id="chkInattention12" className='add-only' value="Inattention12" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInattention13" id="chkInattention13" className='add-only' value="Inattention13" />  Does not follow instructions
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInattention14" id="chkInattention14" className='add-only' value="Inattention14" />  Poor follow-through on tasks
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkHyperactivity1" id="chkHyperactivity1" className='add-only' value="Hyperactivity1" /> <strong>Hyperactivity/Impulsivity</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHyperactivity2" id="chkHyperactivity2" className='add-only' value="Hyperactivity2" />  None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkHyperactivity3" id="chkHyperactivity3" className='add-only' value="Hyperactivity3" />  Feelings of restlessness
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHyperactivity4" id="chkHyperactivity4" className='add-only' value="Hyperactivity4" />  Talks excessively
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkHyperactivity5" id="chkHyperactivity5" className='add-only' value="Hyperactivity5" />  Blurts out answers
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHyperactivity6" id="chkHyperactivity6" className='add-only' value="Hyperactivity6" />  Leaves seat when not
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkHyperactivity7" id="chkHyperactivity7" className='add-only' value="Hyperactivity7" />  Interrupts others
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     appropriate
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkHyperactivity8" id="chkHyperactivity8" className='add-only' value="Hyperactivity8" />  Difficulty in waiting turn
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHyperactivity9" id="chkHyperactivity9" className='add-only' value="Hyperactivity9" />  Runs and climbs
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkHyperactivity10" id="chkHyperactivity10" className='add-only' value="Hyperactivity10" />  Symptoms present before age 12
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHyperactivity11" id="chkHyperactivity11" className='add-only' value="Hyperactivity11" />  Always on the go
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkHyperactivity12" id="chkHyperactivity12" className='add-only' value="Hyperactivity12" />  Several symptoms present in 2 or
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHyperactivity13" id="chkHyperactivity13" className='add-only' value="Hyperactivity13" />  Fidgets with hands/feet
                  </td>
                  <td className='w-300'>
                     more settings
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHyperactivity14" id="chkHyperactivity14" className='add-only' value="Hyperactivity14" />  Hard time playing/leisure
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkHyperactivity15" id="chkHyperactivity15" className='add-only' value="Hyperactivity15" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     activities quietly
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkOppositional1" id="chkOppositional1" className='add-only' value="Oppositional1" /> <strong>Oppositional/Defiant Behaviors</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOppositional2" id="chkOppositional2" className='add-only' value="Oppositional2" />  None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkOppositional3" id="chkOppositional3" className='add-only' value="Oppositional3" />  Intentionally annoying
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOppositional4" id="chkOppositional4" className='add-only' value="Oppositional4" />  Loses temper
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkOppositional5" id="chkOppositional5" className='add-only' value="Oppositional5" />  Defies rules
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOppositional6" id="chkOppositional6" className='add-only' value="Oppositional6" />  Angry frequently
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkOppositional7" id="chkOppositional7" className='add-only' value="Oppositional7" />  Blames others
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOppositional8" id="chkOppositional8" className='add-only' value="Oppositional8" />  Easily annoyed
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkOppositional9" id="chkOppositional9" className='add-only' value="Oppositional9" />  Spiteful
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOppositional10" id="chkOppositional10" className='add-only' value="Oppositional10" />  Argumentative
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkOppositional11" id="chkOppositional11" className='add-only' value="Oppositional11" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkConduct1" id="chkConduct1" className='add-only' value="Conduct1" /> <strong>Conduct Behaviors</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkConduct2" id="chkConduct2" className='add-only' value="Conduct2" />  None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkConduct3" id="chkConduct3" className='add-only' value="Conduct3" />  Lying
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkConduct4" id="chkConduct4" className='add-only' value="Conduct4" />  Bullies others
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkConduct5" id="chkConduct5" className='add-only' value="Conduct5" />  Stays out at night
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkConduct6" id="chkConduct6" className='add-only' value="Conduct6" />  Starts fights
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkConduct7" id="chkConduct7" className='add-only' value="Conduct7" />  Run away
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkConduct8" id="chkConduct8" className='add-only' value="Conduct8" />  Used weapon to cause/threaten
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkConduct9" id="chkConduct9" className='add-only' value="Conduct9" />  Truant
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     harm
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkConduct10" id="chkConduct10" className='add-only' value="Conduct10" />  Destruction of property
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkConduct11" id="chkConduct11" className='add-only' value="Conduct11" />    Theft
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkConduct12" id="chkConduct12" className='add-only' value="Conduct12" />  Aggression toward people/animals
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkConduct13" id="chkConduct13" className='add-only' value="Conduct13" />    Forced sexual activity/other
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkConduct14" id="chkConduct14" className='add-only' value="Conduct14" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     problem sexual behavior
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkConduct15" id="chkConduct15" className='add-only' value="Conduct15" />  Fire setting
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkConduct16" id="chkConduct16" className='add-only' value="Conduct16" />  Broken into house/building/car
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkAutism1" id="chkAutism1" className='add-only' value="Autism1" /> <strong>Autism</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAutism2" id="chkAutism2" className='add-only' value="Autism2" />  None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkAutism3" id="chkAutism3" className='add-only' value="Autism3" />  Extreme distress at small changes
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAutism4" id="chkAutism4" className='add-only' value="Autism4" />  Abnormal social approach
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkAutism5" id="chkAutism5" className='add-only' value="Autism5" />  Highly restricted, fixated interests
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAutism6" id="chkAutism6" className='add-only' value="Autism6" />  Poorly integrated verbal and
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkAutism7" id="chkAutism7" className='add-only' value="Autism7" />  Apparent indifference to pain/temperature
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     nonverbal communciation
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkAutism8" id="chkAutism8" className='add-only' value="Autism8" />  Description(symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAutism9" id="chkAutism9" className='add-only' value="Autism9" />  Difficulty adjusting behavior to
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     suit social contexts
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAutism10" id="chkAutism10" className='add-only' value="Autism10" />  Stereotyped and repetitive
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     movements
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkPersonality1" id="chkPersonality1" className='add-only' value="Personality1" /> <strong>Personality</strong>
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality2" id="chkPersonality2" className='add-only' value="Personality2" />  None reported
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality3" id="chkPersonality3" className='add-only' value="Personality3" />  Problems with interpersonal relationships
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality4" id="chkPersonality4" className='add-only' value="Personality4" />  Frantic efforts to avoid
                  </td>
                  <td className='w-300'>
                     due to odd beliefs
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     abandonment
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality5" id="chkPersonality5" className='add-only' value="Personality5" />  Disregard for other's rights
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality6" id="chkPersonality6" className='add-only' value="Personality6" />  Intense/unstable relationships
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality7" id="chkPersonality7" className='add-only' value="Personality7" />  Irritability and aggressiveness
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality8" id="chkPersonality8" className='add-only' value="Personality8" />  Unstable self-image
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality9" id="chkPersonality9" className='add-only' value="Personality9" />  Lack of remorse
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality10" id="chkPersonality10" className='add-only' value="Personality10" />  Potentially harmful impulsivity
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality11" id="chkPersonality11" className='add-only' value="Personality11" />  Attention seeking
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality12" id="chkPersonality12" className='add-only' value="Personality12" />  Recurrent suicidal behaviors
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality13" id="chkPersonality13" className='add-only' value="Personality13" />  Self dramatization
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality14" id="chkPersonality14" className='add-only' value="Personality14" />  Mood instability
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality15" id="chkPersonality15" className='add-only' value="Personality15" />  Grandiosity
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality16" id="chkPersonality16" className='add-only' value="Personality16" />  Chronic feelings of emptiness
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality17" id="chkPersonality17" className='add-only' value="Personality17" />  Lack of empathy
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality18" id="chkPersonality18" className='add-only' value="Personality18" />  Intense/Inappropriate anger
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality19" id="chkPersonality19" className='add-only' value="Personality19" />  Avoids interpersonal contact
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality20" id="chkPersonality20" className='add-only' value="Personality20" />  Transient, stress-related
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality21" id="chkPersonality21" className='add-only' value="Personality21" />  Submissive/clinging behavior
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     paranoia
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality22" id="chkPersonality22" className='add-only' value="Personality22" />  Fear of separation
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality23" id="chkPersonality23" className='add-only' value="Personality23" />  Pervasive distrust and
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality24" id="chkPersonality24" className='add-only' value="Personality24" />  Preoccuptation with orderliness/perfectionism
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     suspiciousness of others
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality25" id="chkPersonality25" className='add-only' value="Personality25" /> Symptoms are present but client is
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality26" id="chkPersonality26" className='add-only' value="Personality26" />  Believes others' motives are
                  </td>
                  <td className='w-300'>
                     under 18 years of age
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     malevolent
                  </td>
                  <td className='w-300'>
                     <input type="checkbox" name="chkPersonality27" id="chkPersonality27" className='add-only' value="Personality27" />  Description (symptoms, frequency,
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality28" id="chkPersonality28" className='add-only' value="Personality28" />  Restricted range of expressing
                  </td>
                  <td className='w-300'>
                     duration, environment)
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     emotions in relationships
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPersonality29" id="chkPersonality29" className='add-only' value="Personality29" />  Chooses solitary activities
                  </td>
                  <td className='w-300'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <h3>
               MENTAL STATUS EXAM
            </h3>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Dress</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkNeat1" id="chkNeat1" className='add-only' value="Neat1" />  Neat
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkNeat2" id="chkNeat2" className='add-only' value="Neat2" />  Eccentric
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkNeat3" id="chkNeat3" className='add-only' value="Neat3" />  Disheveled
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkNeat4" id="chkNeat4" className='add-only' value="Neat4" />  Age Appropriate
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkNeat5" id="chkNeat5" className='add-only' value="Neat5" />  Sloppy
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkNeat6" id="chkNeat6" className='add-only' value="Neat6" />  Appropriate to situation
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkNeat7" id="chkNeat7" className='add-only' value="Neat7" />  Relaxed
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Appearance</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGood1" id="chkGood1" className='add-only' value="Good1" />  Good hygiene
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGood2" id="chkGood2" className='add-only' value="Good2" />  Poor Hygiene
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkGood3" id="chkGood3" className='add-only' value="Good3" />  Fair Hygiene
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="checkbox" name="chkGood4" id="chkGood4" className='add-only' value="Good4" />  Description:
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtSummaryDescription" name="txtSummaryDescription" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Behavior</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive1" id="chkAttentive1" className='add-only' value="Attentive1" />  Attentive
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive2" id="chkAttentive2" className='add-only' value="Attentive2" />  Demanding
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive3" id="chkAttentive3" className='add-only' value="Attentive3" />  Dependent
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive4" id="chkAttentive4" className='add-only' value="Attentive4" />  Hostile
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive5" id="chkAttentive5" className='add-only' value="Attentive5" />  Guarded
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive6" id="chkAttentive6" className='add-only' value="Attentive6" />  Irritable
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive7" id="chkAttentive7" className='add-only' value="Attentive7" />  Defensive
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive8" id="chkAttentive8" className='add-only' value="Attentive8" />  Passive
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive9" id="chkAttentive9" className='add-only' value="Attentive9" />  Cooperative
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive10" id="chkAttentive10" className='add-only' value="Attentive10" />  Impulsive
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive11" id="chkAttentive11" className='add-only' value="Attentive11" />  Self-destructive
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttentive12" id="chkAttentive12" className='add-only' value="Attentive12" />  Compulsive behaviors
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Eye Contact</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMinimal1" id="chkMinimal1" className='add-only' value="Minimal1" />  Good eye-contact
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMinimal2" id="chkMinimal2" className='add-only' value="Minimal2" />  Minimal eye-contact
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMinimal3" id="chkMinimal3" className='add-only' value="Minimal3" />  No eye-contact
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Motor</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor1" id="chkMotor1" className='add-only' value="Motor1" />  Hyper
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor2" id="chkMotor2" className='add-only' value="Motor2" />  Tics
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor3" id="chkMotor3" className='add-only' value="Motor3" />  Awkward
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor4" id="chkMotor4" className='add-only' value="Motor4" />  Agitated
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor5" id="chkMotor5" className='add-only' value="Motor5" />  Lethargic
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor6" id="chkMotor6" className='add-only' value="Motor6" />  Tremors
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor7" id="chkMotor7" className='add-only' value="Motor7" />  Hypo
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor8" id="chkMotor8" className='add-only' value="Motor8" />  Calm
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor9" id="chkMotor9" className='add-only' value="Motor9" />  Posturing
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor11" id="chkMotor11" className='add-only' value="Motor11" />  Fidgety
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMotor10" id="chkMotor10" className='add-only' value="Motor10" />  Other:
                     <input type="text" id="txtMotor" name="txtMotor" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Language</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLanguage1" id="chkLanguage1" className='add-only' value="Language1" />  Expressive Intact
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLanguage2" id="chkLanguage2" className='add-only' value="Language2" />  Slow Speech
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLanguage3" id="chkLanguage3" className='add-only' value="Language3" />  Receptive intact
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLanguage4" id="chkLanguage4" className='add-only' value="Language4" />  Speech within normal limits
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLanguage5" id="chkLanguage5" className='add-only' value="Language5" />  Spontaneous speech
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLanguage6" id="chkLanguage6" className='add-only' value="Language6" />  Slurred Speech
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLanguage7" id="chkLanguage7" className='add-only' value="Language7" />  Mute
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkLanguage8" id="chkLanguage8" className='add-only' value="Language8" />  Pressured Speech
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Affect/Mood</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect1" id="chkAffect1" className='add-only' value="Affect1" />  Anxious
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect2" id="chkAffect2" className='add-only' value="Affect2" />  Labile
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect3" id="chkAffect3" className='add-only' value="Affect3" />  Calm
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect4" id="chkAffect4" className='add-only' value="Affect4" />  Explosive
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect5" id="chkAffect5" className='add-only' value="Affect5" />  Bright
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect6" id="chkAffect6" className='add-only' value="Affect6" />  Hopeless
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect7" id="chkAffect7" className='add-only' value="Affect7" />  Inappropriate
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect8" id="chkAffect8" className='add-only' value="Affect8" />  Hyper-Vigilant
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect9" id="chkAffect9" className='add-only' value="Affect9" />  Depressed
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect10" id="chkAffect10" className='add-only' value="Affect10" />  Congruent to situation
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect11" id="chkAffect11" className='add-only' value="Affect11" />  Agitated
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect12" id="chkAffect12" className='add-only' value="Affect12" />  Incongruent to situation
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect13" id="chkAffect13" className='add-only' value="Affect13" />  Elevated
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect14" id="chkAffect14" className='add-only' value="Affect14" />  Adequate
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAffect15" id="chkAffect15" className='add-only' value="Affect15" />  Flat
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Thought Form</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought1" id="chkThought1" className='add-only' value="Thought1" />  Logical
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought2" id="chkThought2" className='add-only' value="Thought2" />  Irrelevant
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought3" id="chkThought3" className='add-only' value="Thought3" />  Illogical
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought4" id="chkThought4" className='add-only' value="Thought4" />  Loose Associations
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought5" id="chkThought5" className='add-only' value="Thought5" />  Goal Directed
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought6" id="chkThought6" className='add-only' value="Thought6" />  Distractible
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought7" id="chkThought7" className='add-only' value="Thought7" />  Sequential
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought8" id="chkThought8" className='add-only' value="Thought8" />  Blocking
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought9" id="chkThought9" className='add-only' value="Thought9" />  Indecisive
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought10" id="chkThought10" className='add-only' value="Thought10" />  Tangential
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought11" id="chkThought11" className='add-only' value="Thought11" />  Circumstantial
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought12" id="chkThought12" className='add-only' value="Thought12" />  Unexplained dizziness
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought13" id="chkThought13" className='add-only' value="Thought13" />  Concrete
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought14" id="chkThought14" className='add-only' value="Thought14" />  Obsessive Thinking
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought15" id="chkThought15" className='add-only' value="Thought15" />  Flight of Ideas
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThought16" id="chkThought16" className='add-only' value="Thought16" />  Relevant
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Thought Content</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent1" id="chkThoughtContent1" className='add-only' value="ThoughtContent1" />  Suicidal
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent2" id="chkThoughtContent2" className='add-only' value="ThoughtContent2" />  Hopelessness
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent3" id="chkThoughtContent3" className='add-only' value="ThoughtContent3" />  Delusions
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent4" id="chkThoughtContent4" className='add-only' value="ThoughtContent4" />  Suspicious
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent5" id="chkThoughtContent5" className='add-only' value="ThoughtContent5" />  Homicidal
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent6" id="chkThoughtContent6" className='add-only' value="ThoughtContent6" />  Phobias
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent7" id="chkThoughtContent7" className='add-only' value="ThoughtContent7" />  Future Oriented
                  </td>
                  <td className='w-500'>
                     <input type="checkbox" name="chkThoughtContent8" id="chkThoughtContent8" className='add-only' value="ThoughtContent8" />  Dwells on issues of separation or loss
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent9" id="chkThoughtContent9" className='add-only' value="ThoughtContent9" />  Obsessions
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent10" id="chkThoughtContent10" className='add-only' value="ThoughtContent10" />  Grandiose
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent11" id="chkThoughtContent11" className='add-only' value="ThoughtContent11" />  Hallucinations
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent12" id="chkThoughtContent12" className='add-only' value="ThoughtContent12" />  Guilt
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkThoughtContent13" id="chkThoughtContent13" className='add-only' value="ThoughtContent13" />  Somatic
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Orientation</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOrientation1" id="chkOrientation1" className='add-only' value="Orientation1" />  Person
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOrientation2" id="chkOrientation2" className='add-only' value="Orientation2" />  Time
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOrientation3" id="chkOrientation3" className='add-only' value="Orientation3" />  Place
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOrientation4" id="chkOrientation4" className='add-only' value="Orientation4" />  Situation
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Intellect</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntellect1" id="chkIntellect1" className='add-only' value="Intellect1" />  Suspected to be Above Aerage
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntellect2" id="chkIntellect2" className='add-only' value="Intellect2" />  Known Disability
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntellect3" id="chkIntellect3" className='add-only' value="Intellect3" />  Uncertain
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntellect4" id="chkIntellect4" className='add-only' value="Intellect4" />  Average
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntellect5" id="chkIntellect5" className='add-only' value="Intellect5" />  Below Average
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Memory</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMemory1" id="chkMemory1" className='add-only' value="Memory1" />  Adequate
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMemory2" id="chkMemory2" className='add-only' value="Memory2" />  Remote
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMemory3" id="chkMemory3" className='add-only' value="Memory3" />  Impaired
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMemory4" id="chkMemory4" className='add-only' value="Memory4" />  Selective
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMemory5" id="chkMemory5" className='add-only' value="Memory5" />  Recent
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkMemory6" id="chkMemory6" className='add-only' value="Memory6" />  Other:
                     <input type="text" id="txtDatePresOther1" name="txtDatePresOther1" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Perceptions</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPerceptions1" id="chkPerceptions1" className='add-only' value="Perceptions1" />  Unremarkable
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPerceptions2" id="chkPerceptions2" className='add-only' value="Perceptions2" />  Traumatic Flashbacks
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPerceptions3" id="chkPerceptions3" className='add-only' value="Perceptions3" />  Auditory Hallucinations
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPerceptions4" id="chkPerceptions4" className='add-only' value="Perceptions4" />  Ideas of References
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPerceptions5" id="chkPerceptions5" className='add-only' value="Perceptions5" />  Visual Hallucinations
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPerceptions6" id="chkPerceptions6" className='add-only' value="Perceptions6" />  Depersonalization
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Judgement/Insight</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInsight1" id="chkInsight1" className='add-only' value="Insight1" />  Poor
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInsight2" id="chkInsight2" className='add-only' value="Insight2" />  Good
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInsight3" id="chkInsight3" className='add-only' value="Insight3" />  Fair
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkInsight4" id="chkInsight4" className='add-only' value="Insight4" />  Impaired
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Impulse Control</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkImpulse1" id="chkImpulse1" className='add-only' value="Impulse1" />  Poor
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkImpulse2" id="chkImpulse2" className='add-only' value="Impulse2" />  Adequate/Age Appropriate
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkImpulse3" id="chkImpulse3" className='add-only' value="Impulse3" />  Needs to be addressed
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkImpulse4" id="chkImpulse4" className='add-only' value="Impulse4" />  Impaired
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Attention/Concentration</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttention1" id="chkAttention1" className='add-only' value="Attention1" />  Adequate
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttention2" id="chkAttention2" className='add-only' value="Attention2" />  Moderately Distractible
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttention3" id="chkAttention3" className='add-only' value="Attention3" />  Mildly Distractible
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkAttention4" id="chkAttention4" className='add-only' value="Attention4" />  Severely Distractible
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <h3>
               RISK ASSESSMENT
            </h3>
            <p className='w-750'>
               <input type="checkbox" name="chkFactors" id="chkFactors" className='add-only' value="Factors" />  No risk factors identified
            </p>
            <h3>
               Suicide Risk Screening Tool
            </h3>
            <p className='w-750'>
               <span className='eleHeader'>1. In the past few weeks, have you wished you were dead</span>
               <input type="radio" id="rbScreening1_Yes" name="rbScreening1" className='add-only' value="1" /> Yes
               <input type="radio" id="rbScreening1_No" name="rbScreening2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>2. In the past few weeks, have you felt that you or your family would be better off if you were dead?</span>
               <input type="radio" id="rbScreening2_Yes" name="rbScreening2" className='add-only' value="1" /> Yes
               <input type="radio" id="rbScreening2_No" name="rbScreening2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>3. In the past week, have you been having thoughts about killing yourself?</span>
               <input type="radio" id="rbScreening3_Yes" name="rbScreening3" className='add-only' value="1" /> Yes
               <input type="radio" id="rbScreening3_No" name="rbScreening3" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>4. Have you ever tried to kill yourself?</span>
               <input type="radio" id="rbScreening4_Yes" name="rbScreening4" className='add-only' value="1" /> Yes
               <input type="radio" id="rbScreening4_No" name="rbScreening4" className='add-only' value="0" /> No
            </p>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>If Yes, how?</span>
                     <input type="text" id="txtIndividualsYes" name="txtIndividualsYes" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>When</span>
                     <input type="text" id="txtWhen" name="txtWhen" className='add-only' />
                  </td>
               </tr>
            </table>
            <h4>
               5. If the client answers YES to any of the above, ask the following acuity question:
            </h4>
            <p className='w-750'>
               <span className='eleHeader'>Are you having thoughts of killing yourself right now?</span>
               <input type="radio" id="rbScreening5_Yes" name="rbScreening5" className='add-only' value="1" /> Yes
               <input type="radio" id="rbScreening5_No" name="rbScreening5" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               If yes, please describe:
               <textarea id="txtSummaryDescribe" name="txtSummaryDescribe" className='add-only'></textarea>
            </p>
            <h4>
               Next Steps:
            </h4>
            <ul>
               <li>
                  If client answers "NO" to all questions 1 through 4, screening is complete (not necessary to ask questions #5).
                  No intervention necessary (*note: Clinical judgement can always override a negative screen).
               </li>
               <li>
                  If the client answers "YES" to any questions 1 through 4, or refuses to answer, they are considered a
                  positive screen. Ask question #5 to assess acuity:
               </li>
            </ul>
            <p className='w-750'>
               <input type="checkbox" name="chkQuestion" id="chkQuestion" className='add-only' value="Question" />  "YES" to question # 5 = acute positive screen (imminent risk identified)
            </p>
            <p className='w-750'>
               - Client requires a STAT safety/full mental health evaluation
            </p>
            <p className='w-750'>
               - Client cannot leave until evaluated for safety.
            </p>
            <p className='w-750'>
               - Keep patient in sight. Remove all dangerous objects from room. Alert physician or clinician responsible for patient's care.
            </p>
            <p className='w-750'>
               <input type="checkbox" name="chkQuestion2" id="chkQuestion2" className='add-only' value="Question2" />   "NO" to question # 5 = non-acute positive screen (potential risk identified)
            </p>
            <p className='w-750'>
               - Client requires a brief suicide safety assessment to determine if a full mental health evaluation is needed. Client cannot leave until evaluated for safety.
            </p>
            <p className='w-750'>
               - Alert physician or clinician responsible for patient's care.
            </p>
            <h4>
               Provide resources to all client
            </h4>
            <ul>
               <li>
                  24/7 National Suicide Prevention Lifeline 1-800-273-TALK (8255) En Espanol: 1-888-628-9454
               </li>
               <li>
                  24/7 Crisis Text Line: Text "HOME" to 741-741
               </li>
            </ul>
            <h4>
               Adapted from: AsQ Suicide Risk Screening Toolkit National Institute of Mental Health (NIMH)
            </h4>
            <table>
               <tr>
                  <td className='w-100'>
                     &nbsp;
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Low</span>
                  </td>
                  <td className='w-200'>
                     <span className='eleHeader'>Medium </span><span className='small'>(complete safety plan)</span>
                  </td>
                  <td className='w-200'>
                     <span className='eleHeader'>High </span><span className='small'>(complete safety plan)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     <strong> Thoughts of self harm</strong>
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbThoughts1_Yes" name="rbThoughts1" className='add-only' value="1" />  No current thoughts (48 hours)
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbThoughts1_Ys" name="rbThoughts1" className='add-only' value="0" />  Vague current thoughts
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbThoughts1_Ye" name="rbThoughts1" className='add-only' value="2" />  Recurrent active thoughts
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     <strong> Method</strong>
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbThoughts2_Yes" name="rbThoughts2" className='add-only' value="1" />  No plan
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbThoughts2_Ys" name="rbThoughts2" className='add-only' value="0" />  Plan without intent
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbThoughts2_Ye" name="rbThoughts2" className='add-only' value="2" />  Plan with intent
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     <strong> Availability of means</strong>
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbThoughts3_Yes" name="rbThoughts3" className='add-only' value="1" />  No access
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbThoughts3_Ys" name="rbThoughts3" className='add-only' value="0" />  Have easy access
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbThoughts3_Ye" name="rbThoughts3" className='add-only' value="2" />  In hand or used
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <input type="checkbox" name="chkAttempts" id="chkAttempts" className='add-only' value="Attempts" />  History of attempts
            </p>
            <p className='w-750'>
               <strong>Dates of Attempts:</strong> <input type="date" id="txtAttemptsDate" name="txtAttemptsDate" className='add-only' />
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Method:</span>
               <textarea id="txtSummaryReasonMethod" name="txtSummaryReasonMethod" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Triggers:</span>
               <textarea id="txtTriggers" name="txtTriggers" className='add-only'></textarea>
            </p>
            <h3>
               Risk of Harm to Others
            </h3>
            <table>
               <tr>
                  <td className='w-750'>
                     <strong>Method</strong>
                  </td>
               </tr>
               <tr>
                  <td className='w-125'>
                     <span className='eleHeader'>Low</span>
                  </td>
                  <td className='w-275'>
                     <span className='eleHeader'>Medium </span><span className='small'>(complete safety plan)</span>
                  </td>
                  <td className='w-350'>
                     <span className='eleHeader'>High </span><span className='small'>(complete safety plan)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-125'>
                     <input type="radio" id="rbThoughtsMethod1_Yes" name="rbThoughtsMethod1" className='add-only' value="1" />  No plan
                  </td>
                  <td className='w-275'>
                     <input type="radio" id="rbThoughtsMethod1_Ys" name="rbThoughtsMethod1" className='add-only' value="0" />  Plan without intent
                  </td>
                  <td className='w-350'>
                     <input type="radio" id="rbThoughtsMethod1_Ye" name="rbThoughtsMethod1" className='add-only' value="2" />  Plan with intent
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <strong>Availability of means</strong>
                  </td>
               </tr>
               <tr>
                  <td className='w-125'>
                     <span className='eleHeader'>Low</span>
                  </td>
                  <td className='w-275'>
                     <span className='eleHeader'>Medium </span><span className='small'>(complete safety plan)</span>
                  </td>
                  <td className='w-350'>
                     <span className='eleHeader'>High </span><span className='small'>(complete safety plan)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-125'>
                     <input type="radio" id="rbThoughtsMethod2_Yes" name="rbThoughtsMethod2" className='add-only' value="1" />  No access
                  </td>
                  <td className='w-275'>
                     <input type="radio" id="rbThoughtsMethod2_Ys" name="rbThoughtsMethod2" className='add-only' value="0" />  Has access
                  </td>
                  <td className='w-350'>
                     <input type="radio" id="rbThoughtsMethod2_Ye" name="rbThoughtsMethod2" className='add-only' value="2" />  In hand
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <strong>Intent</strong>
                  </td>
               </tr>
               <tr>
                  <td className='w-125'>
                     <span className='eleHeader'>Low</span>
                  </td>
                  <td className='w-275'>
                     <span className='eleHeader'>Medium </span><span className='small'>(complete safety plan)</span>
                  </td>
                  <td className='w-350'>
                     <span className='eleHeader'>High </span><span className='small'>(complete safety plan)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-125'>
                     <input type="radio" id="rbThoughtsMethod3_Yes" name="rbThoughtsMethod3" className='add-only' value="1" />  Vague intent
                  </td>
                  <td className='w-275'>
                     <input type="radio" id="rbThoughtsMethod3_Ys" name="rbThoughtsMethod3" className='add-only' value="0" />  Intends to cause physical harm
                  </td>
                  <td className='w-350'>
                     <input type="radio" id="rbThoughtsMethod3_Ye" name="rbThoughtsMethod3" className='add-only' value="2" />  Clearly intends on inflicting harm
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <strong>Notification Required</strong>
                  </td>
               </tr>
               <tr>
                  <td className='w-125'>
                     <span className='eleHeader'>Low</span>
                  </td>
                  <td className='w-275'>
                     <span className='eleHeader'>Medium </span><span className='small'>(complete safety plan)</span>
                  </td>
                  <td className='w-350'>
                     <span className='eleHeader'>High </span><span className='small'>(complete safety plan)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     <input type="radio" id="rbThoughtsMethod4_Yes" name="rbThoughtsMethod4" className='add-only' value="1" />  No need
                  </td>
                  <td className='w-275'>
                     <input type="radio" id="rbThoughtsMethod4_Ys" name="rbThoughtsMethod4" className='add-only' value="0" />  Identifiable person is aware
                  </td>
                  <td className='w-350'>
                     <input type="radio" id="rbThoughtsMethod4_Ye" name="rbThoughtsMethod4" className='add-only' value="2" />  A person needs to be warned to ensure safety
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Additional Information</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkViolence" id="chkViolence" className='add-only' value="Violence" />  Family history of violence
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkViolence" id="chkViolence" className='add-only' value="Violence" />  History of impulsive behavior
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkViolence" id="chkViolence" className='add-only' value="Violence" />  Previous homicide attempts
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkViolence" id="chkViolence" className='add-only' value="Violence" />  Active psychosis
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkViolence" id="chkViolence" className='add-only' value="Violence" />  History of fire setting
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <input type="checkbox" name="chkViolence" id="chkViolence" className='add-only' value="Violence" />  Other
                     <input type="text" id="txtOrderOther" name="txtOrderOther" className='add-only' />
                  </td>
               </tr>
            </table>
            <h3>
               DIAGNOSIS
            </h3>
            <table>
               <tr>
                  <td className='w-150'>
                     &nbsp;
                  </td>
                  <td className='w-100'>
                     <span className='eleHeader'>Code</span>
                  </td>
                  <td className='w-150'>
                     <span className='eleHeader'>Description</span>
                  </td>
               </tr>
               <tr>
                  <td rowSpan={4}>
                     <strong>List in order of clinical
                        significance:</strong>
                  </td>
                  <td className='w-100'>
                     <input type="text" id="txtCode1" name="txtCode1" className='add-only' />
                  </td>
                  <td className='w-500'>
                     <input type="text" id="txtDescription1" name="txtDescription1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     <input type="text" id="txtCode2" name="txtCode2" className='add-only' />
                  </td>
                  <td className='w-500'>
                     <input type="text" id="txtDescription2" name="txtDescription2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     <input type="text" id="txtCode3" name="txtCode3" className='add-only' />
                  </td>
                  <td className='w-500'>
                     <input type="text" id="txtDescription3" name="txtDescription3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-100'>
                     <input type="text" id="txtCode4" name="txtCode4" className='add-only' />
                  </td>
                  <td className='w-500'>
                     <input type="text" id="txtDescription4" name="txtDescription4" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td colSpan={2}>
                     <span className='eleHeader'>V Codes:</span>
                  </td>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <input type="checkbox" name="chkViolenceCodes1" id="chkViolenceCodes1" className='add-only' value="ViolenceCodes1" />  V15.41 Personal History of Physical or Sexual Abuse
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkViolenceCodes2" id="chkViolenceCodes2" className='add-only' value="ViolenceCodes2" />  V62.3 Academic or Educational Problem
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkViolenceCodes3" id="chkViolenceCodes3" className='add-only' value="ViolenceCodes3" />  V62.5 Problems Related to Legal Circumstances
                  </td>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <input type="checkbox" name="chkViolenceCodes4" id="chkViolenceCodes4" className='add-only' value="ViolenceCodes4" />  V60.2 Extreme Poverty; Low Income; Inadequate Food, Water or Welfare Support
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkViolenceCodes5" id="chkViolenceCodes5" className='add-only' value="ViolenceCodes5" />  V60.9 Unspecified Economic or Housing Problem
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkViolenceCodes6" id="chkViolenceCodes6" className='add-only' value="ViolenceCodes6" />  V62.81 Relational Problem NOS
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkViolenceCodes7" id="chkViolenceCodes7" className='add-only' value="ViolenceCodes7" />  V61.20 Parent-Child Relational Problem
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkViolenceCodes8" id="chkViolenceCodes8" className='add-only' value="ViolenceCodes8" />  V62.82 Bereavement
                  </td>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <input type="checkbox" name="chkViolenceCodes9" id="chkViolenceCodes9" className='add-only' value="ViolenceCodes9" />  V61.03 Disruption of Family by Separation or Divorce
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkViolenceCodes10" id="chkViolenceCodes10" className='add-only' value="ViolenceCodes10" />  V62.89 Phase of Life Problem
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkViolenceCodes11" id="chkViolenceCodes11" className='add-only' value="ViolenceCodes11" />  V61.8 Sibling Relational Problem
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" name="chkViolenceCodes12" id="chkViolenceCodes12" className='add-only' value="ViolenceCodes12" />  OTHER:
                     <input type="text" id="txtOutcomeComplianceCodes" name="txtOutcomeComplianceCodes" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" name="chkViolenceCodes13" id="chkViolenceCodes13" className='add-only' value="ViolenceCodes13" />  V62.29 Problem Related to Employment
                  </td>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <input type="checkbox" name="chkViolenceCodes14" id="chkViolenceCodes14" className='add-only' value="ViolenceCodes14" />  OTHER:
                     <input type="text" id="txtOutcomeComplianceCodes1" name="txtOutcomeComplianceCodes1" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>CLINICAL IMPRESSION / INTERPRETIVE SUMMARY </span><span className='small'>(ALSO INCLUDE: Risk of harm; functional status, comorbidity,
                  recovery, environment, treatment and recovery history, adjustment to disability or current conditions.):</span>
               <textarea id="txtSummaryTreatment1" name="txtSummaryTreatment1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Clinical Justification for Services </span><span className='small'>(What is the reason the recommended service is the medically necessary
                  service at this time? Consider the eligibility requirements for the service. Please include additional recommendations for
                  services, testing/assessment, and/or medical, pain, or nutritional follow up):</span>
               <textarea id="txtSummaryTreatment2" name="txtSummaryTreatment2" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Summarize the issues that the agency can realistically assist client in resolving, the level of care needed, and the
                  expected focus  </span><span className='small'>(goals).</span>
               <textarea id="txtSummaryTreatment3" name="txtSummaryTreatment3" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td colSpan={5}>
                     <span className='eleHeader'>Motivation to engage in services</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="checkbox" name="chkMotivation1" id="chkMotivation1" className='add-only' value="Motivation1" />  pre-contemplation
                  </td>
                  <td className='w-150'>
                     <input type="checkbox" name="chkMotivation2" id="chkMotivation2" className='add-only' value="Motivation2" />  contemplation
                  </td>
                  <td className='w-150'>
                     <input type="checkbox" name="chkMotivation3" id="chkMotivation3" className='add-only' value="Motivation3" />  preparation
                  </td>
                  <td className='w-150'>
                     <input type="checkbox" name="chkMotivation4" id="chkMotivation4" className='add-only' value="Motivation4" />  action
                  </td>
                  <td className='w-150'>
                     <input type="checkbox" name="chkMotivation5" id="chkMotivation5" className='add-only' value="Motivation5" />  maintenance
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Comments:</span>
               <textarea id="txtComments" name="txtComments" className='add-only'></textarea>
            </p>
            <h3>
               TREATMENT RECOMMENDATIONS
            </h3>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Assessment</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological" id="chkPsychological" className='add-only' value="Psychological" />  Psychological Testing
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological" id="chkPsychological" className='add-only' value="Psychological" />  Educational Testing
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological" id="chkPsychological" className='add-only' value="Psychological" />  Neurological Evaluation
                  </td>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <input type="checkbox" name="chkPsychological" id="chkPsychological" className='add-only' value="Psychological" />  Psychiatric Medication Assessment
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological" id="chkPsychological" className='add-only' value="Psychological" />  UCLA-RI
                  </td>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <input type="checkbox" name="chkPsychological" id="chkPsychological" className='add-only' value="Psychological" />  Sexual Offense Specific Evaluation
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological" id="chkPsychological" className='add-only' value="Psychological" />  Medical/Physical Exam
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkPsychological" id="chkPsychological" className='add-only' value="Psychological" />  SASSI
                  </td>
                  <td colSpan={2}>
                     <input type="checkbox" name="chkPsychological" id="chkPsychological" className='add-only' value="Psychological" />  Other (specify)
                     <input type="text" id="txtPsychological" name="txtPsychological" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Emergency Services</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="checkbox" name="chkEmergency" id="chkEmergency" className='add-only' value="Emergency" />  Mobile Crisis Team
                  </td>
                  <td className='w-200'>
                     <input type="checkbox" name="chkEmergency" id="chkEmergency" className='add-only' value="Emergency" />  Hospitalization
                  </td>
                  <td className='w-350'>
                     <input type="checkbox" name="chkEmergency" id="chkEmergency" className='add-only' value="Emergency" />  Other
                     <input type="text" id="txtEmergency" name="txtEmergency" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Outpatient Mental Health Services</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOutpatient1" id="chkOutpatient1" className='add-only' value="Outpatient1" />  Referral to MCO
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOutpatient2" id="chkOutpatient2" className='add-only' value="Outpatient2" />  Parenting Skills
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOutpatient3" id="chkOutpatient3" className='add-only' value="Outpatient3" />  Individual Therapy
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOutpatient4" id="chkOutpatient4" className='add-only' value="Outpatient4" />  Community Support Team
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOutpatient5" id="chkOutpatient5" className='add-only' value="Outpatient5" />  Family Therapy
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOutpatient6" id="chkOutpatient6" className='add-only' value="Outpatient6" />  TFCBT
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOutpatient7" id="chkOutpatient7" className='add-only' value="Outpatient7" />  Group Therapy
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkOutpatient8" id="chkOutpatient8" className='add-only' value="Outpatient8" />  Dialectal Behavior Therapy
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="checkbox" name="chkOutpatient" id="chkOutpatient" className='add-only' value="Outpatient" />  Other
                     <input type="text" id="txtOutpatient" name="txtOutpatient" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Intensive Mental Health Services</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive1" id="chkIntensive1" className='add-only' value="Intensive1" />  Community Support Team
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive2" id="chkIntensive2" className='add-only' value="Intensive2" />  Therapeutic Foster Care
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive3" id="chkIntensive3" className='add-only' value="Intensive3" />  ACTT
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive4" id="chkIntensive4" className='add-only' value="Intensive4" />  Residential Level 2
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive5" id="chkIntensive5" className='add-only' value="Intensive5" />  Therapeutic Foster Care
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive6" id="chkIntensive6" className='add-only' value="Intensive6" />  Residential Level 3
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive7" id="chkIntensive7" className='add-only' value="Intensive7" />  Intensive In-Home Services
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive8" id="chkIntensive8" className='add-only' value="Intensive8" />  Residential Level 4
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive9" id="chkIntensive9" className='add-only' value="Intensive9" />  Family Centered Treatment (FCT)
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive10" id="chkIntensive10" className='add-only' value="Intensive10" />  Residential PRTF
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive11" id="chkIntensive11" className='add-only' value="Intensive11" />  Multi-Systemic Therapy
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkIntensive12" id="chkIntensive12" className='add-only' value="Intensive12" />  Day Treatment
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="checkbox" name="chkIntensive13" id="chkIntensive13" className='add-only' value="Intensive13" />  Multi-Systemic Therapy Problem Sexual
                     Behavior Treatment (MST-PSB)
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Developmental Disability Services</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkDevelopmental" id="chkDevelopmental" className='add-only' value="Developmental" />  Referral to MCO
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkDevelopmental" id="chkDevelopmental" className='add-only' value="Developmental" />  Developmental Therapies
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Support Groups/Peer Support</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSupportGroups1" id="chkSupportGroups1" className='add-only' value="SupportGroups1" />  Alcoholics Anon
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSupportGroups2" id="chkSupportGroups2" className='add-only' value="SupportGroups2" />  COSA Groups
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSupportGroups3" id="chkSupportGroups3" className='add-only' value="SupportGroups3" />  Narcotics Anon
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSupportGroups4" id="chkSupportGroups4" className='add-only' value="SupportGroups4" />  Peer Support
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSupportGroups5" id="chkSupportGroups5" className='add-only' value="SupportGroups5" />  Gamblers Anon
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSupportGroups6" id="chkSupportGroups6" className='add-only' value="SupportGroups6" />  Therapy Groups
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="checkbox" name="chkSupportGroups7" id="chkSupportGroups7" className='add-only' value="SupportGroups7" />  Alateen/Alanon
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Vocational/Educational</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkVocational1" id="chkVocational1" className='add-only' value="Vocational1" />  Vocational Rehab
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkVocational2" id="chkVocational2" className='add-only' value="Vocational2" />  Supportive Employment
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkVocational3" id="chkVocational3" className='add-only' value="Vocational3" />  GED program
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="checkbox" name="chkVocational4" id="chkVocational4" className='add-only' value="Vocational4" />  Transitional Living
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Housing/Financial/Legal</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkVocational1" id="chkVocational1" className='add-only' value="Vocational1" />  Legal Assistance
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkVocational2" id="chkVocational2" className='add-only' value="Vocational2" />  Housing Assistance
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkVocational3" id="chkVocational3" className='add-only' value="Vocational3" />  Financial Assistance
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="checkbox" name="chkVocational4" id="chkVocational4" className='add-only' value="Vocational4" />  Food/Clothing Assistance
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Substance Abuse</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSubstanceAbuse1" id="chkSubstanceAbuse1" className='add-only' value="SubstanceAbuse1" />  Detox
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSubstanceAbuse2" id="chkSubstanceAbuse2" className='add-only' value="SubstanceAbuse2" />  Inpatient
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSubstanceAbuse3" id="chkSubstanceAbuse3" className='add-only' value="SubstanceAbuse3" />  SAIOP
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSubstanceAbuse4" id="chkSubstanceAbuse4" className='add-only' value="SubstanceAbuse4" />  Halfway House
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkSubstanceAbuse5" id="chkSubstanceAbuse5" className='add-only' value="SubstanceAbuse5" />  SACOT
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Holistic Treatment Recommendations</span>
                  </td>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <input type="checkbox" name="chkHolistic1" id="chkHolistic1" className='add-only' value="Holistic1" />  Physical Activity ( increased exercise)
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHolistic2" id="chkHolistic2" className='add-only' value="Holistic2" />  Yoga
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHolistic3" id="chkHolistic3" className='add-only' value="Holistic3" />  Dietary and Nutritional Changes
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHolistic4" id="chkHolistic4" className='add-only' value="Holistic4" />  Meditation
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHolistic5" id="chkHolistic5" className='add-only' value="Holistic5" />  Mindfulness
                  </td>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <input type="checkbox" name="chkHolistic6" id="chkHolistic6" className='add-only' value="Holistic6" />  Promoting Mental Health In Spirituality
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHolistic7" id="chkHolistic7" className='add-only' value="Holistic7" />  Mind Body Exercise
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHolistic8" id="chkHolistic8" className='add-only' value="Holistic8" />  Massage Therapy
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHolistic9" id="chkHolistic9" className='add-only' value="Holistic9" />  Increase Social Interaction
                  </td>
                  <td className='w-250'>
                     <input type="checkbox" name="chkHolistic10" id="chkHolistic10" className='add-only' value="Holistic10" />  Art Therapy
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Parent/Guardian/Caregiver Feedback</span>
               <textarea id="txtGuardianCaregiver" name="txtGuardianCaregiver" className='add-only'></textarea>
            </p>
            <h3>
               MULTI-SYSTEMIC THERAPY PRE-SCREENING
            </h3>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>NAME:</span>
                     <input type="text" id="txtFrequencyName" name="txtFrequencyName" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>DATE:</span>
                     <input type="date" id="txtDurationDate" name="txtDurationDate" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>MEDICAID NUMBER:</span>
                     <input type="text" id="txtIntensityMedicaid" name="txtIntensityMedicaid" className='add-only' />
                  </td>
               </tr>
            </table>
            <h3>
               Entrance Criteria
            </h3>
            <h4>
               The recipient is eligible for this service when:
            </h4>
            <p className='w-750'>
               <input type="checkbox" name="chkDiagnosis1" id="chkDiagnosis1" className='add-only' value="Diagnosis1" />  A. There is an Axis I or II diagnosis present, other than a sole diagnosis of Developmental
               Disability.
            </p>
            <h4>
               AND
            </h4>
            <p className='w-750'>
               <input type="checkbox" name="chkDiagnosis2" id="chkDiagnosis2" className='add-only' value="Diagnosis2" />  B. The client should be between the ages of 7 through 17.
            </p>
            <h4>
               AND
            </h4>
            <p className='w-750'>
               <input type="checkbox" name="chkDiagnosis3" id="chkDiagnosis3" className='add-only' value="Diagnosis3" />  C. The client displays willful behavioral misconduct (e.g., theft, property destruction, assault,
               communicating verbal threats, other status offense, truancy or substance use/abuse or juvenile sex offense).
            </p>
            <h4>
               AND
            </h4>
            <p className='w-750'>
               <input type="checkbox" name="chkDiagnosis4" id="chkDiagnosis4" className='add-only' value="Diagnosis4" />  D. The client is at imminent risk of out-of-home placement or is currently in out-of-home placement due to
               delinquency and reunification is imminent within 30 days of referral.
            </p>
            <h4>
               AND
            </h4>
            <p className='w-750'>
               <input type="checkbox" name="chkDiagnosis5" id="chkDiagnosis5" className='add-only' value="Diagnosis5" />  E. The client has a caregiver that is willing to assume long term parenting role and caregiver who is willing
               to participate with service providers for the duration of the treatment.
            </p>
            <table>
               <tr>
                  <td className='signature w-450'> &nbsp; </td>
                  <td className='signature w-300'> &nbsp; </td>
               </tr>
               <tr>
                  <td className="small w-450"> Signature </td>
                  <td className="small w-300"> Date </td>
               </tr>
            </table>
            <h3>
               I. Person Receiving Services:
            </h3>
            <p className='w-750'>
               <input type="checkbox" name="chkReceiving" id="chkReceiving" className='add-only' value="Receiving" />  I confirm my involvement in the reporting of clinical information used in the development of this
               Comprehensive Clinical Assessment.
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Legally Responsible Person: Self:</span>
               <input type="radio" id="rbLegally_Yes" name="rbLegally" className='add-only' value="1" />  Yes
               <input type="radio" id="rbLegally_No" name="rbLegally" className='add-only' value="0" />  No
            </p>
            <p className='w-750'>
               <strong>Person Receiving Services:</strong> (Required when person is his/her own legally responsible person)
            </p>
            <table>
               <tr>
                  <td className='signature w-300'> &nbsp; </td>
                  <td className='signature w-300'> &nbsp; </td>
                  <td className='signature w-150'> &nbsp; </td>
               </tr>
               <tr>
                  <td className="small w-300"> Signature </td>
                  <td className="small w-300"> Print Name </td>
                  <td className="small w-150"> Date </td>
               </tr>
            </table>
            <p className='w-750'>
               <strong>Legally Responsible Person: (Required if other than person receiving services)</strong>
            </p>
            <table>
               <tr>
                  <td className='signature w-300'> &nbsp; </td>
                  <td className='signature w-300'> &nbsp; </td>
                  <td className='signature w-150'> &nbsp; </td>
               </tr>
               <tr>
                  <td className="small w-300"> Signature </td>
                  <td className="small w-300"> Print Name </td>
                  <td className="small w-150"> Date </td>
               </tr>
            </table>
            <p className='w-750'>
               Relationship to the individual: <input type="text" id="txtRelationship" name="txtRelationship" className='add-only' />
            </p>
            <h3>
               II. Person Responsible For The Comprehensive Clinical Assessment:
            </h3>
            <p className='w-750'>
               <input type="checkbox" name="chkReceiving2" id="chkReceiving2" className='add-only' value="Receiving2" />  I confirm responsibility for the development of this Comprehensive Clinical Assessment.
            </p>
            <table>
               <tr>
                  <td className='signature w-300'> &nbsp; </td>
                  <td className='signature w-300'> &nbsp; </td>
                  <td className='signature w-150'> &nbsp; </td>
               </tr>
               <tr>
                  <td className="small w-300"> Signature (with credentials) </td>
                  <td className="small w-300"> Print Name </td>
                  <td className="small w-150"> Date </td>
               </tr>
            </table>


         </div>
      </form>

   )
}  
